// fr_CA.ts

const messages = {
  'default.welcome': 'Bonjour!',
  // Global keys for navbar, header, footer
  navbar: {
    addresses: 'Correction d’adresse',
    accessApiKey: `Clé d'API - Administration`,
    adminVeterinarians: 'Médecins vétérinaires',
    apiKeys: `Clés d'API`,
    category: 'Catégories',
    dashboard: 'Tableau de bord',
    graphsAndDashboard: 'Graphiques et tableaux',
    omvq: 'OMVQ',
    permitHolder: 'Détenteur de permis',
    producerReport: 'Rapport - Producteur',
    registrations: 'Suivi des inscriptions',
    reportExtract: 'Rapport/Extraction',
    report: 'Rapport',
    reports: 'Rapports',
    reportDownload: 'Données codifiées',
    reportSector: 'Rapport sectoriel',
    requestAccess: `Inscription au monitorage (consentement)`,
    system: 'Système',
    rdDashboard: 'Tableau de bord R & D',
    userDashboard: 'Tableau de bord utilisateur',
    veterinarian: 'Vétérinaire',
    vetReport: 'Rapport - Vétérinaire',
  },
  header: {
    env: {
      dev: 'Environnement de développement',
      staging: 'Environnement de test (préproduction)',
      text: ', vos données ne seront pas transférées dans la production.',
    },
  },
  api: {
    systemMessage: 'Message du système',
    validationError: 'Erreur de validation au serveur.',
  },
  // Global keys for app functionalities
  app: {
    accept: 'Accepter',
    actions: 'Actions',
    activate: 'Activer',
    add: 'Ajouter',
    apply: 'Appliquer',
    backHome: `Retour à l'accueil`,
    backList: 'Retour à la liste',
    cancel: 'Annuler',
    choose: 'Choisir',
    clear: 'Vider',
    close: 'Fermer',
    confirm: 'Confirmer',
    dateMax: 'Date limite maximale',
    dateMin: 'Date limite minimale',
    deactivate: 'Désactiver',
    delete: 'Supprimer',
    edit: 'Modifier',
    emailSent: 'Un courriel vous a été envoyé.',
    enterDate: 'Entrez une date',
    enterValue: 'Entrez une valeur',
    expired: 'expiré',
    filter: 'Filtrer',
    impersonation: 'Personnification en cours',
    importCSV: 'Importer fichier CSV',
    no: 'Non',
    noResult: 'Aucun résultat',
    notImplemented: 'Pas encore implémenté',
    remove: 'Retirer',
    reset: 'Réinitialiser',
    resetFilters: 'Réinitialiser les filtres',
    resetFilter: 'Réinitialiser le filtre',
    resetSort: 'Réinitialiser les tris',
    save: 'Sauvegarder',
    search: 'Rechercher',
    secureConfirm: 'Veuillez copier le code dans le champ ci-dessous.',
    selectDate: 'Choisir la date',
    selectYear: `Choisir l'année`,
    send: 'Envoyer',
    total: 'Total',
    transmit: 'Transmettre',
    viewTooltip: `Vue d'ensemble`,
    viewList: 'Consulter la liste',
    yes: 'Oui',
    ok: 'OK',
  },
  // Global keys for entity fields
  field: {
    accessCode: `Code d'accès`,
    accessLevel: `Niveau d'accès`,
    active: 'Actif',
    activeIngredient: 'Ingrédient actif',
    activeIngredientType: `Type d'ingrédient actif`,
    address: 'Adresse',
    brandName: 'Médicament commercial',
    canHaveSite: 'Peut avoir un site',
    category: 'Catégorie',
    city: 'Ville',
    code: 'Code',
    codeAi: 'Numéro FMV',
    codeAntibiotiQC: 'Code AntibiotiQC',
    codeCDMV: 'Code CDMV',
    codeFmv: 'Numéro FMV',
    company: 'Compagnie',
    concentration: 'Concentration',
    concentration_BDPP: 'Concentration BDPP (emballage)',
    concentration_base: 'Concentration base',
    count: 'Occurences',
    country: 'Pays',
    date: 'Date',
    declaration: 'Déclaration',
    declarationId: 'N° de déclaration',
    declarationType: 'Type de déclaration',
    declarationYear: 'Année de déclaration',
    description: 'Description',
    din: 'DIN',
    dinNumber: 'Numéro DIN',
    directionName: 'Nom de la direction en charge',
    directionNumber: 'N° de la direction en charge',
    division: 'Division',
    email: 'Courriel',
    endAt: 'Date de fin',
    endDate: 'Date de fin',
    endYear: 'Année de fin',
    entityNumber: `N° de l'entité`,
    entityStatus: `Statut d'entité`,
    entityType: `Type d'entité`,
    expiryDate: `Date d'expiration`,
    accessCodeExpiryDate: `Date d'expiration du code d'accès`,
    familyCode: 'Code de famille',
    familyFr: 'Description française de la famille',
    finalAddress: 'Adresse finale',
    formattedAddress: 'Adresse déclarée',
    id: 'N°',
    inactive: 'Inactif',
    ingredientFamily: `Famille d'ingrédient`,
    ingredientStatus: 'Déclaration par ingrédient',
    inspectionSection: `Secteur d'inspection`,
    latitude: 'Latitude',
    lastActivityDate: 'Dernière activité',
    longitude: 'Longitude',
    localAdministrationName: `Nom du bureau d'inspection`,
    localAdministrationNumber: `N° de l'administration locale`,
    mapaqPermitNumber: 'N° de permis BAK',
    matchStatus: 'Type de jumelage',
    medication: 'Médicament',
    medicationClass: 'Classe de médicament',
    medicationType: 'Type de médicament',
    medicationTypes: 'Types de médicaments',
    mill: 'Fournisseur',
    monitoringConsent: 'Consentement monitorage',
    month: 'Mois',
    municipality: 'Municipalité',
    name: 'Nom',
    nameProp: 'nameFr',
    note: 'Note',
    officialSite: 'Numéro de site réglementé',
    omvqStatus: 'Statut OMVQ',
    operatorNumber: `Numéro de l'entreprise`,
    ordonnanceQc: 'Ordonnance (QC)',
    organization: 'Association',
    organizationDepartment: 'Département',
    organizationProducerNumber: 'Numéro CPC',
    ownerFullName: 'Nom du propriétaire',
    password: 'Mot de passe',
    permit: 'Permis',
    permitHolder: 'Détenteur de permis',
    permitNumber: 'N° de permis',
    permitStatus: 'Statut de permis',
    permitType: 'Catégorie de permis',
    permitTypes: 'Catégories de permis',
    pharmaceuticalForm: 'Forme pharmaceutique',
    phone: 'Téléphone',
    phoneNumber: 'Numéro de téléphone',
    poBox: 'Boîte postale',
    postalCode: 'Code postal',
    precision: 'Précision obligatoire',
    producer: 'Producteur',
    product: 'Produit',
    productionSite: 'Site de production',
    productionStageGroup: 'Regroupement',
    productType: 'Type de produit',
    providerNumber: 'N° de référence interne',
    province: 'Province',
    recipient: 'Client',
    reducedActiveIngredient: 'Ingrédient actif réduit',
    regionAdministrativeDescription: `Description de l'administration régionale`,
    regionAdministrativeNumber: `N° de l'administration régionale`,
    requestId: 'Numéro de demande',
    requestStatus: 'Statut de la demande',
    requestStatusDetail: 'Détail du statut',
    role: 'Rôle',
    routeOfAdministration: `Voie d'administration`,
    ruralRoute: 'Route rurale',
    shortName: 'Nom court',
    shortNameProp: 'shortNameFr',
    site: 'Site',
    siteName: 'Nom du site',
    siteNumber: 'N° de traçabilité du site',
    sitePermitNumber:
      'N° de permis relatif aux prémélanges médicamenteux et aliments médicamenteux du site',
    source: 'Mode de transmission',
    species: 'Espèce',
    standardConcentration: 'Concentration standardisée',
    startAt: 'Date de début',
    startDate: 'Date de début',
    startYear: 'Année de début',
    stationInformation: 'Succursale',
    status: 'Statut',
    statusDate: 'Date de statut',
    transactionDate: 'Date de transaction',
    transmissionDate: 'Date de transmission',
    streetName: 'Nom de rue',
    streetNumber: 'N° de rue',
    type: 'Type',
    unit: 'Unité',
    unitInfoFr: `Précision sur l'unité standard`,
    unitLimit: `Unité d'âge`,
    unitNumber: `N° d'appartement`,
    unitRequired: 'Unité standard acceptée',
    updatedAt: 'Date de modification',
    user: 'Utilisateur',
    validationStatus: 'Statut de validation',
    veterinarian: 'Vétérinaire',
    veterinarianDoctor: 'Médecin vétérinaire',
    year: `Année`,
  },
  // Global keys for app messages
  message: {
    activate: {
      confirm: 'Êtes-vous certain de vouloir activer cet élément?',
      error: `L'activation de l'élément a échoué.`,
      success: `L'élément a été activé avec succès.`,
    },
    activateMulti: {
      confirm: 'Êtes-vous certain de vouloir activer les éléments sélectionnés?',
      error: `L'activation des éléments a échoué.`,
      success: 'Les éléments ont été activés avec succès.',
    },
    add: {
      confirm: 'Êtes-vous certain de vouloir ajouter cet élément?',
      error: `L'ajout de l'élément a échoué.`,
      success: `L'élément a été ajouté avec succès.`,
    },
    deactivate: {
      confirm: 'Êtes-vous certain de vouloir désactiver cet élément?',
      error: `La désactivation de l'élément a échoué.`,
      success: `L'élément a été désactivé avec succès.`,
    },
    deactivateMulti: {
      confirm: 'Êtes-vous certain de vouloir désactiver les éléments sélectionnés?',
      error: `La désactivation des éléments a échoué.`,
      success: 'Les éléments ont été désactivés avec succès.',
    },
    delete: {
      confirm: 'Êtes-vous certain de vouloir supprimer cet élément?',
      error: `La suppresion de l'élément a échoué.`,
      success: `L'élément a été supprimé avec succès.`,
    },
    deleteMulti: {
      confirm: 'Êtes-vous certain de vouloir supprimer les éléments sélectionnés?',
      error: 'La suppresion des éléments a échoué.',
      success: 'Les éléments ont été supprimés avec succès.',
    },
    edit: {
      confirm: 'Êtes-vous certain de vouloir modifier cet élément?',
      error: `La modification de l'élément a échoué.`,
      success: `L'élément a été modifié avec succès.`,
    },
    editMulti: {
      confirm: 'Êtes-vous certain de vouloir modifier les éléments sélectionnés?',
      error: 'La modification des éléments a échoué.',
      success: 'Les éléments ont été modifiés avec succès.',
    },
    errorUsedResource: 'Action impossible, la ressource est utilisée dans le système',
    notificationTitle: 'Message du système',
  },
  // Global keys for form validation
  validation: {
    error: {
      emptyValue: 'Ce champ doit être rempli',
      siteNumber: 'Le format du numéro de site est incorrect',
      sitePermitNumber: 'Le format du numéro de permis est incorrect',
    },
    serverError: 'Erreur de validation au serveur.',
    systemMessage: 'Message du système',
  },
  // Specific keys for modules / entities
  activeIngredient: {
    add: 'Ajouter un ingrédient actif',
    BDPP: {
      title: 'Ingrédients actifs (BDPP)',
    },
    FMV: {
      add: 'Ajouter un ingrédient actif',
      list: 'Ingrédients actifs (calculs et rapports)',
      title: 'Ingrédients actifs et concentration base',
    },
    labelIsPermitHolder: 'Ingredient détenteur de permis',
    labelOrdonnanceQc: 'Ordonnance (QC)',
    list: 'Ingrédients actifs (emballage)',
    title: 'Ingrédients actifs',
    tableListerTitle: 'Ingrédients actifs et concentration standardisée',
    tableListerConcentrationBdppTitle: 'Ingrédients actifs et concentration BDPP (emballage)',
    titleFormAdd: 'Ajouter un ingrédient actif',
    titleFormEdit: 'Modifier un ingrédient actif',
    messageAddSuccess: "L'ingrédient actif a été ajouté avec succès.",
    messageEditSuccess: "L'ingrédient actif a été modifié avec succès.",
    messageDeleteSuccess: "L'ingrédient actif a été supprimé avec succè.s",
    messageActivatedSuccess: 'Les ingrédients actifs ont été activés avec succès.',
    messageDeactivatedSuccess: 'Les ingrédients actifs ont été désactivés avec succès.',
    remove: `Retirer l'ingrédient actif`,
    unit: {
      PPM: 'ppm',
      G_KG: 'g/kg',
      MG_G: 'mg/g',
      MG_ML: 'mg/ml',
      MG_UNIT: 'mg/unité',
    },
    unitUnsupported: 'valeur non supportée',
  },
  address: {
    clear: `Vider l'adresse`,
    clearForm: `Vider le formulaire d'adresse`,
    clearFormConfirm: `Vous êtes sur le point de vider le formulaire d'adresse. Voulez-vous continuer?`,
    enter: 'Entrez une adresse',
    find: 'Trouver une adresse',
    lineOne: 'Ligne adresse 1',
    lineTwo: 'Ligne adresse 2',
    city: 'Ville',
    province: 'Province',
    state: 'État',
    postalCode: 'Code postal',
    country: 'Pays',
    unitNumber: 'App.',
    civicNumber: 'N° rue',
    streetName: 'Nom rue',
    poBox: 'Boîte postale',
    stationInformation: 'Succursale',
    ruralRoute: 'Route rurale',
    dividerOthersFields: `Autres champs d'adresse`,
    globalValidation:
      'Vous devez remplir une de ces conditions: ligne adresse 1, Boîte postale, Route rurale ou numéro et nom de rue.',
  },
  division: {
    selectMulti: 'Choisir les divisions',
  },
  dashboard: {
    filtersReset: 'Réinitialiser les filtres du tableau de bord',
    filterTitle: 'Filtre de tableau de bord: {suffix}',
  },
  declaration: {
    add: 'Ajouter une déclaration',
    create: {
      error: 'La création de la déclaration a échoué.',
      success: 'La déclaration a été créée avec succès.',
    },
    edit: {
      error: 'La modification de déclaration contient des erreurs, veuillez les corriger.',
      success: 'La modification de déclaration est transmise avec succès.',
    },
    error: {
      duplicate: {
        title: 'Doublons détectés',
        details:
          'Votre déclaration n\'a pas été transmise à cause de la présence de doublons. Vous pouvez quand même transmettre votre déclaration en cliquant sur le bouton "Transmettre" ou cliquer sur le lien "Voir la liste des doublons" pour consulter la liste.',
        viewList: 'Voir la liste des doublons',
      },
      incomplete: {
        title: 'Déclaration incomplète',
        details: `
          Votre déclaration ne peut pas être transmise tant qu'elle sera incomplète. Veuillez corriger :
          <ul>{list}</ul>
          Votre déclaration est sauvegardée dans les déclarations en attente si vous devez la compléter ultérieurement.
          {br}
          Afin de vous conformer au Règlement, vous êtes tenu de transmettre vos déclarations de ventes et de fournitures au plus tard le 31 mars de l'année suivant celle de la vente ou de fourniture.
        `,
        message: `Vous avez une ou plusieurs déclarations incomplètes, cliquez sur l'îcone {icon} pour plus de détails.`,
      },
    },
    declarationType: {
      SALE_SUPPLY: 'Vente ou fourniture',
      RETURN: 'Retour',
    },
    medicationIngredient: 'Médicament/Ingrédient',
    savedState: 'État sauvegardé',
    titleLister: 'Déclarations',
    transmit: {
      error: 'La transmission de déclaration contient des erreurs, veuillez les corriger.',
      errorMulti: 'transmissions de déclaration contiennent des erreurs, veuillez les corriger.',
      success: 'La nouvelle déclaration a été transmise avec succès.',
      successMulti: 'Les {number} nouvelles déclarations ont été transmises avec succès.',
    },
    labelDeclarationDate: 'Transaction',
    labelDeclarationCreatedAt: 'Transmission',
    labelDeclarationRecipientName: 'Client',
    labelPermit: 'Permis du déclarant',
    siteProduction: 'Site de production',
    messageDeleteSuccess: 'La déclaration a été supprimée avec succès.',
    labelDeclarationProduct: 'Produit',
    editTitle: 'Modifier une déclaration',
    site: {
      address: 'Adresse du site',
      addressInfo: `Adresse où sont localisés les animaux auxquels sont destinés les prémélanges ou les aliments médicamenteux vendus ou fournis. Notez que celle-ci peut différer de l'adresse principale du client.`,
      addressRecipient: 'Utiliser la même adresse que le client pour ce site',
      coordinateConfirm: 'Voulez-vous utiliser ces coordonnées?',
      coordinateInfo: 'Vous avez déjà entré des coordonnées pour le {prefix} :',
      coordinateNotice: `
        <b>Bovin, ovin et cervidé :</b> Le numéro de traçabilité du site (SimpliTRACE : QC9999999) est suffisant.
        {br}
        {br}
        <b>Porcin :</b> L'adresse complète du site est requise. Le numéro de traçabilité du site (PorcTRACÉ : QC9999999) est souhaité.
        {br}
        {br}
        <b>Volaille :</b> L’adresse complète du site est requise. Le numéro de poulailler est souhaité.
        {br}
        {br}
        <b>Caprin :</b> L’adresse complète du site est requise. Le numéro de traçabilité du site (Portail d’identification des sites du Québec : QC9999999) est souhaité.
        {br}
        {br}
        <b>Autres espèces :</b> L'adresse complète du site est requise.
        {br}
        {br}
      `,
      coordinateNoticeTitle: 'Coordonnées des sites de production animale',
      update: {
        editableFields: 'Liste des champs à mettre à jour',
        editCount: `Vous allez modifier {dataCount} {dataCount,plural,one{déclaration}other{déclarations}}.`,
        infoBlock: `Vous pouvez mettre à jour les informations suivantes pour toutes les déclarations concernant un même site de production : le <b>numéro de traçabilité</b>, le <b>numéro de permis</b> ou le <b>nom</b>.<ol><li>Filtrer les déclarations en cliquant sur l’icône entonnoir qui est située à droite dans chaque colonne.</li><li>Valider les résultats.</li><li>Cliquer sur le bouton “Modifier” pour appliquer la modification souhaitée.</li></ol>`,
        title: 'Modification de site',
      },
    },
    siteNumber: 'N° de site {siteNumber}',
    siteNumberAddressInfo: `Pour une vente ou une fourniture destinée à des bovins, ovins ou cervidés, si le numéro de traçabilité du site est fourni, l'adresse du site n'est pas requise.`,
    siteNumberInfo:
      'La plateforme AntibiotiQC est configurée pour valider le numéro de traçabilité du site pour les bovins, les ovins et les cervidés qui sont visés par le Règlement sur l’identification et la traçabilité de certains animaux, découlant de la Loi sur la protection sanitaire des animaux. Dans l’environnement de test préproduction, pour ces espèces seuls les numéros suivants sont acceptés : QC0000000, QC1111111, QC2222222, QC3333333, QC4444444, QC5555555, QC6666666, QC7777777, QC8888888 et QC9999999. ',
    sitePermitNumber: 'N° de permis {sitePermitNumber}',
    sitePermitNumberInfo: `Pour toute vente ou fourniture de <b>prémélange</b> médicamenteux, le client doit obligatoirement
      posséder un permis relatif aux prémélanges médicamenteux et aliments médicamenteux, en lien avec le site concerné par
      ladite vente ou fourniture.{br}{br}Si vous n'avez pas cette information, il vous est possible de la rechercher sur
      le site Web du gouvernement du Québec. <mapaqPermitLink>Cliquez ici</mapaqPermitLink>`,
  },
  epqAccessRequest: {
    add: {
      action: 'Ajouter une inscription',
      title: 'Ajouter une inscription au monitorage',
    },
    confirm: {
      accept: 'Voulez-vous vraiment accepter cette demande?',
      analyze: 'Voulez-vous vraiment analyser cette demande?',
      cancel: 'Voulez-vous vraiment annuler cette demande?',
      delete: 'Voulez-vous vraiment supprimer cette demande?',
      refuse: 'Voulez-vous vraiment refuser cette demande?',
      removeConsentBypass:
        'Confirmer la désinscription en ignorant les erreurs EPQ? (environnement de test uniquement)',
    },
    edit: {
      error: `La modification de l'inscription au monitorage a échoué.`,
      success: `L'inscription au monitorage a été modifiée avec succès.`,
      title: 'Modifier une inscription au monitorage',
    },
    linkExisting: 'Lier une inscription existante',
    message: {
      acceptSuccess: `L'inscription au monitorage a été acceptée avec succès.`,
      activateSuccess: `La demande d'inscription au monitorage a été liée à votre compte avec succès.`,
      addSuccess: `La demande d'inscription au monitorage a été transmise avec succès.`,
      editSuccess: `La demande d'inscription au monitorage a été modifiée avec succès.`,
      analyzeSuccess: `L'inscription au monitorage a été analysée avec succès.`,
      cancelSuccess: `L'inscription au monitorage a été annulée avec succès.`,
      deleteSuccess: `L'inscription au monitorage a été supprimée avec succès.`,
      refuseSuccess: `L'inscription au monitorage a été refusée avec succès.`,
      requestStatus: {
        ACCEPTED: `L'inscription au monitorage a été acceptée.`,
        REFUSED: `L'inscription au monitorage a été refusée.`,
      },
    },
    modal: {
      cancelRequest: {
        confirmation: `Voulez-vous vraiment annuler cette demande?`,
        label: `Raison de l'annulation`,
        title: `Annulation de la demande d'inscription`,
      },
      removeConsent: {
        text1: 'Voulez-vous vraiment retirer votre consentement au Monitorage?',
        text2:
          'Veuillez noter que vous devrez refaire une demande d’inscription si vous voulez donner votre consentement à nouveau.',
        text3: `
          <t>
            Pour demander la suppression de vos informations et entraîner la destruction de vos renseignements personnels
            récoltés dans le cadre de la portion volontaire du Monitorage, vous devez vous adresser au MAPAQ à l’adresse
            <mapaqInfo>accesinformation@mapaq.gouv.qc.ca</mapaqInfo>. Pour être recevable, votre demande de suppression doit s’appuyer
            sur une justification suffisante comme un préjudice lié à l’utilisation des renseignements ou le fait que
            celle-ci contrevienne à la loi ou à une ordonnance judiciaire. Contrairement à un simple retrait, il est
            important de noter que cette suppression entraînera la perte de vos données de Monitorage volontaires précédemment
            collectées. Par conséquent, si vous décidez de participer à nouveau au Monitorage, l’historique de vos données
            volontaires ne sera plus disponible.
          </t>
        `,
        success: `La demande d’inscription au monitorage a été retirée avec succès.`,
        title: 'Retrait du consentement au monitorage',
      },
      registerRequest: {
        register: `Remplir une demande d'inscription`,
        link: `Lier une inscription existante`,
        text1: `Si vous êtes le propriétaire des animaux, vous devez lire les informations sur l’inscription et remplir le formulaire d’inscription.`,
        text2: `Si vous avez reçu un code d’accès à titre de gestionnaire ou de délégué, vous devez lier une inscription existante à votre compte.`,
        title: `Demande d'inscription au système de monitorage`,
      },
    },
    producer_EPQ: 'Les Éleveurs de porcs du Québec',
    producer_PLQ: 'Les Producteurs de lait du Québec',
    producer_EVQ: 'Les Éleveurs de volailles du Québec',
    title: 'Monitorage - consentement, partage et accès',
    tooltip: {
      accept: 'Accepter la demande',
      analyze: 'Analyser la demande',
      cancel: 'Annuler la demande',
      delete: 'Supprimer la demande',
      manageUsers: 'Partage et accès',
      manageUsersRoles: '(gestionnaire, délégué et vétérinaire)',
      refuse: 'Refuser la demande',
      removeConsent: 'Retirer le consentement au monitorage',
      removeConsentBypass: 'Retirer le consentement au monitorage (bypass EPQ — NON PROD)',
    },
  },
  epqRequestCompany: {
    name: `Nom de l’entreprise et personne contact`,
    select: 'Choisissez une entreprise',
    selectInfo: `L’accès aux données est limité aux sites que les propriétaires d’animaux ou leurs gestionnaires ont partagés avec vous.`,
    contact: 'Coordonnées',
  },
  epqRequestUserAccess: {
    accessLevel: {
      MANAGER: 'Gestionnaire',
      OWNER: 'Propriétaire',
      USER: 'Délégué',
      VET: `Vétérinaire (partage de rapport)`,
    },
    add: {
      error: `L'ajout de l'accès a échoué.`,
      success: `Accès a été ajouté avec succès.`,
      title: `Choisir un niveau d'accès`,
    },
    delete: {
      confirm: `Êtes-vous certain de vouloir supprimer cet accès?`,
      error: `La suppression de l'accès a échoué.`,
      success: `L'accès a été supprimé avec succès.`,
    },
    edit: {
      confirmActivate: `Êtes-vous certain de vouloir activer cet accès?`,
      confirmDeactivate: `Êtes-vous certain de vouloir désactiver cet accès?`,
      editStatus: 'Modification du statut',
      error: `La modification de l'accès a échoué.`,
      success: `L'accès a été modifié avec succès.`,
    },
    access: 'Accès',
    associatedUser: 'Utilisateur associé',
    descriptionManagerIntro: `Vous pourrez transmettre le code d'accès généré à la personne de votre choix.`,
    descriptionManagerAllows: `Ce gestionnaire pourra : `,
    descriptionManagerItem1: `Accorder des accès à d’autres utilisateurs pour les sites qui lui sont assignés (étape suivante);`,
    descriptionManagerItem2_1: `Consulter le`,
    descriptionManagerItem2_2: `Rapport – Producteur`,
    descriptionManagerItem2_3: `pour les sites qui lui sont assignés (étape suivante);`,
    descriptionManagerItem3: `Consulter la liste des accès accordés à l’ensemble des utilisateurs;`,
    descriptionManagerItem4: `Consulter les renseignements saisis dans le formulaire d’inscription au monitorage, à l’exception du code d’autorisation.`,
    descriptionUserIntro: `Vous pourrez transmettre le code d'accès généré à la personne de votre choix.`,
    descriptionUserAllows: `Ce délégué pourra consulter le`,
    descriptionUserItem1_1: `Consulter le`,
    descriptionUserItem1_2: `Rapport – Producteur`,
    descriptionUserItem1_3: `pour les sites qui lui sont assignés (étape suivante).`,
    descriptionUserNote_1: `L’identité des fournisseurs (meuneries et établissements vétérinaires vendeurs) ne sera pas affichée dans le tableau`,
    descriptionUserNote_2: `Résumé des achats`,
    descriptionUserNote_3: `qui lui sera partagé.`,
    descriptionVetPara1_1: `Le médecin vétérinaire sélectionné ci-dessous aura instantanément accès au`,
    descriptionVetPara1_2: `Rapport – Producteur`,
    descriptionVetPara1_3: `pour les sites sélectionnés (étape suivante).`,
    descriptionVetNote_1: `L'identité des fournisseurs (meuneries et établissements vétérinaires vendeurs) ne sera pas affichée dans le tableau`,
    descriptionVetNote_2: `Résumé des achats`,
    descriptionVetNote_3: `partagé avec le vétérinaire.`,
    notApplicable: 's. o.',
    selectType: `Choisir le type d'utilisateur`,
    subtitle: '{code} - Demande #{id}',
    title: 'Partage et accès',
    editRole: {
      error: `La modification du niveau d'accès a échoué.`,
      success: `Le niveau d'accès a été modifié avec succès.`,
      title: `Modifier le niveau d'accès`,
    },
    tooltip: {
      activate: `Activer le code d'accès`,
      delete: `Supprimer le code d'accès`,
      deleteVetAccess: `Supprimer l'accès`,
      editRole: `Modifier le niveau d'accès`,
      manageSites: 'Gérer les divisions et sites',
    },
    veterinarian: `Médecin vétérinaire`,
  },
  epqRequestUserAccessDetail: {
    division: {
      add: 'Ajouter la division',
      remove: 'Retirer la division',
      title: 'Liste des divisions',
    },
    site: {
      add: 'Ajouter le site',
      title: 'Liste des sites',
    },
    notAssociated: 'Utilisateur',
    selected: 'Divisions et sites sélectionnés',
    subtitle: '{name} - {level}',
    success: `Les accès de l'utilisateur ont été modifiés avec succès.`,
    title: 'Liste des divisions et sites associés à la demande',
  },
  finalAddress: {
    correctedAddress: 'Adresse corrigée',
    edit: {
      confirm: `Voulez-vous vraiment changer l'adresse {current} par {new}?`,
      confirmNoMatch: `Voulez-vous vraiment supprimer le jumelage d'adresse?`,
      confirmNote: `Voulez-vous vraiment modifier la note pour cette adresse?`,
      error: `La mise à jour de l'adresse a échoué.`,
      finalAddressEmpty: 'Vous devez entrer une nouvelle adresse.',
      icherche: 'Corriger via iCherche',
      manual: 'Corriger manuellement',
      subtitleInfo: `Corriger l'adresse déclarée en adresse finale en trouvant la bonne adresse via iCherche ou en l'indiquant manuellement.`,
      subtitleWarning1: 'ATTENTION',
      subtitleWarning2: `Vous ne devez pas changer l’adresse postale, simplement améliorer la précision de cette dernière. Par exemple, vous ne devez pas modifier le numéro civique.`,
      success: `L'adresse à été mise à jour avec succès.`,
      title: `Correction d'adresse`,
    },
    filter: {
      all: 'Tous',
      bakEntity: 'BAK - Entité',
      bakOperator: 'BAK - Opérateur',
      clientDeclaration: 'Déclaration - client',
      matchedAddresses: 'Adresses jumelées',
      showAddresses: 'Afficher les adresses',
      siteDeclaration: 'Déclaration - site',
      withNote: 'Avec une note',
      withoutNote: 'Sans note',
    },
    matchStatus: {
      AUTO: 'Automatique',
      ICHERCHE: 'iCherche manuellement',
      MANUAL: 'Manuellement',
      NO_MATCH: 'Aucun jumelage',
      NO_STATUS: 'Aucun statut',
    },
    title: 'Liste des adresses finales',
  },
  ingredientFamily: {
    add: {
      success: `La famille d’ingrédient à été ajoutée avec succès.`,
      title: `Ajouter une famille d'ingrédient`,
    },
    edit: {
      error: `La mise à jour de la famille d'ingrédient a échoué.`,
      success: `La famille d'ingrédient à été mise à jour avec succès.`,
      title: `Modifier une famille d'ingrédient`,
    },
    title: `Familles d'ingrédients`,
  },
  medication: {
    excel: {
      administrationRoute: 'Route d`administration #{increment}',
      BDPPStatus: 'Statut BDPP',
      dinNumber: 'DIN #{increment}',
      drugCode: 'Code de produit BDPP',
      descriptor: 'Description',
      ingredientCode: `Code de l'ingrédient actif #{increment}`,
      ingredientName: `Nom de l'ingrédient actif #{increment}`,
      ingredientConcentration: `Concentration de l'ingrédient actif #{increment}`,
      ingredientUnit: `Unité de mesure de l'ingredient actif #{increment}`,
      ingredientMedicationType: `Type de médicament des ingrédients actifs #{increment}`,
      ingredientFmvCode: `Code de l'ingrédient actif BDPP #{increment}`,
      ingredientFmvName: `Nom de l'ingrédient actif BDPP #{increment}`,
      ingredientFmvConcentration: `Concentration de l'ingrédient actif BDPP #{increment}`,
      ingredientFmvUnit: `Unité de mesure de l'ingredient actif BDPP #{increment}`,
      companyCode: `Code de compagnie`,
      companyName: `Compagnie`,
      medicationPharmaceuticalForm_nameFr: `Nom de forme pharmaceutique #{increment}`,
      medicationCdmvCode_code: `Code CDMV #{increment}`,
      medicationType_ActiveIngredient: `Type d'ingrédient actif #{increment}`,
    },
    FMV: {
      drugCode: 'Numéro de médicament FMV',
    },
    isPermitHolder: 'Médicament détenteur de permis',
    view: {
      title: 'Information sur le médicament',
      noNote: 'Aucune note',
    },
    title: 'Médicaments commerciaux',
    titleAdd: 'Ajouter un médicament commercial',
    titleEdit: 'Modifier un médicament commercial',
    medicationClass: {
      HUMAN: 'Humain',
      VET: 'Vétérinaire',
      vetOrHuman: 'Vétérinaire ou humain',
    },
    unitRequired: {
      G: 'Gramme',
      ML: 'Millilitre',
      UNIT: 'Unité',
    },
    validationStatus: {
      APPROVED: 'Approuvé',
      PENDING_APPROVAL_FMV: 'En attente (FMV)',
      PENDING_APPROVAL_MAPAQ: 'En attente (MAPAQ)',
      none: 'Aucun',
    },
  },
  medicationActiveIngredient: {
    standardConcentrationUnit: {
      MG_JAR: 'mg/bocal',
      MG_BOLUS: 'mg/bol',
      MG_BOTTLE: 'mg/bouteille',
      MG_CAP: 'mg/capsule',
      MG_PAD: 'mg/compresse',
      MG_TAB: 'mg/comprimé',
      MG_VIAL: 'mg/fiole',
      MG_G: 'mg/g',
      MG_IMPLANT: 'mg/implant',
      MG_ML: 'mg/ml',
      MG_OVULE: 'mg/ovule',
      MG_DRESSING: 'mg/pansement',
      MG_LOZ: 'mg/pastille',
      MG_BAG: 'mg/sac',
      MG_PCK: 'mg/sachet-paquet',
      MG_PAIL: 'mg/seau',
      MG_SYR: 'mg/seringue',
      MG_SUP: 'mg/suppositoire',
      MG_PATCH: 'mg/timbre',
    },
  },
  medicationDin: {
    dinNumber: {
      add: `Ajouter un numéro d'identification de médicament (DIN)`,
      delete: `Retirer un numéro d'identification de médicament (DIN)`,
      label: `Numéro d'identification de médicament (DIN)`,
      list: `Liste des numéros d'identification de médicament (DIN)`,
    },
    endDateTooltip: `Date à laquelle le MAPAQ a été informé du retrait du DIN (ex. : Alerte courriel de l'ACIA).`,
  },
  medicationImport: {
    list: `Liste de l'historique des importations de médicaments`,
  },
  omvqEstablishment: {
    title: 'Établissements vétérinaires',
  },
  omvqVeterinarian: {
    title: 'Vétérinaires',
    statuses: {
      ACTIVE: 'Actif',
      INACTIVE: 'Inactif',
      INACTIVE_18_MONTH: 'Inactif depuis + de 18 mois',
      SUSPENDED: 'En Suspens',
    },
  },
  organization: {
    excel: {
      addressSecond: 'Adresse 2',
      authorizedDomain: 'Domaine autorisé #{increment}',
      stationInformation: 'Information sur la station',
      unitNumber: `Numéro d'unité`,
      organizationSpecies: 'Espèce #{increment}',
      streetNumber: 'Numéro de rue',
    },
    select: `Choisissez l'association`,
    title: 'Associations',
  },
  permit: {
    accessCode: `Code d'accès du permis`,
    active: 'Statut AntibiotiQC',
    entityCityName: `Nom de la municipalité de l'entité`,
    entityCityNumber: `N° de municipalité de l'entité`,
    entityCivicNumber: `N° civique de l'entité`,
    entityCommonName: 'Appellation commune',
    entityFractionNumber: `N° de fraction de l'entité`,
    entityManager: `Responsable de l'entité`,
    entityManagerPhoneExtension: 'N° de poste du responsable entité',
    entityManagerPhoneNumber: 'N° téléphone du responsable entité',
    entityPhoneExtension: 'No de poste entité',
    entityPhoneNumber: 'No téléphone entité',
    entityPostalCode: `Code postal de l'entité`,
    entitySocialReason: 'Raison sociale',
    entityStatus: {
      A: 'Établissement actif/en opération',
      AP: 'Établissement est en attente',
      FA: 'Établissement sous juridiction fédéral actif',
      FI: 'Établissement sous juridiction fédéral inactif',
      I: 'Établissement inactif/fermé',
    },
    entityStreetName: `Nom de rue de l'entité`,
    entityUnitNumber: `N° d'appartement de l'entité`,
    excel: {
      code: `Code d'accès #{increment}`,
      entitySocialReason: `Raison sociale de l'entité`,
      expiryDate: `Date d'expiration #{increment}`,
      operatorName: `Nom de l'exploitant`,
      streetName: 'Rue',
      streetNumber: 'N° civique',
    },
    expiryDate: `Date d'expiration du permis`,
    ingredientStatus: {
      APPROVED: 'Approuvé par le MAPAQ',
      NOT_AUTHORIZED: 'Non autorisé',
      PENDING: `En attente d'approbation`,
    },
    list: 'Liste des permis',
    mapaqExpiryDate: `Date d'expiration MAPAQ`,
    mapaqIssueDate: 'Date de délivrance MAPAQ',
    mapaqPermitStatus: 'Statut du permis MAPAQ',
    mapaqPermitType: 'Catégorie de permis MAPAQ',
    messageAddSuccess: 'Le permis a été ajouté avec succès.',
    messageEditSuccess: 'Le permis a été modifié avec succès.',
    messageDeleteSuccess: 'Le permis a été supprimé avec succès.',
    operatorCityName: `Municipalité de l'exploitant`,
    operatorCityNumber: `N° de municipalité de l'exploitant`,
    operatorCivicNumber: `N° civique de l'exploitant`,
    operatorContact: `Contact de l'exploitant`,
    operatorEmail: `Courriel de l'exploitant`,
    operatorFractionNumber: `N° de fraction de l'exploitant`,
    operatorName: `Nom abrégé de l'exploitant`,
    operatorNumber: `N° de l'exploitant`,
    operatorPhoneExtension: `N° poste téléphonique de l'exploitant`,
    operatorPhoneNumber: `N° téléphone de l'exploitant`,
    operatorPostalCode: `Code postal de l'exploitant`,
    operatorStreetName: `Nom de rue de l'exploitant`,
    operatorUnitNumber: `N° d'appartement de l'exploitant`,
    permitStatus: {
      A: 'Permis actif',
      C: 'Permis annulé avec remboursement',
      T: 'Permis temporaire',
      L: 'Lettre de réclamation émise',
      X: 'Permis annulé sans remboursement',
    },
    permitType: {
      P: `Préparation d'un aliment médicamenteux`,
      M: `Préparation d'un prémélange médicamenteux ou d'un aliment médicamenteux`,
      S: `Vente ou fourniture d'un prémélange médicamenteux ou d'un aliment médicamenteux`,
      V: `Vente, fourniture et préparation d'un prémélange médicamenteux ou d'un aliment médicamenteux`,
    },
    select: 'Choisir le permis',
    statusHistoryList: `Liste de l'historique des statuts`,
    title: 'Permis',
    titleFormAdd: 'Ajouter un permis',
    titleFormEdit: 'Modifier un permis',
    view: {
      subtitle: '{number} - {name}',
      title: 'Information sur le permis',
    },
  },
  permitCode: {
    add: `Ajouter un code d'accès`,
    apiKeySelect: `Choisir la clé d'API`,
    apiKeyExpiresOn: `expire le`,
    codeTypeSelect: 'Choisir le type de code',
    codeType: {
      ADMIN: 'Gestionnaire de permis',
      API_KEY: `Clé d'API`,
      USER: 'Délégué',
    },
    edit: `Modifier un code d'accès`,
    title: `Code d'accès`,
  },
  permitCodeActivation: {
    link: 'Lier un permis à mon profil',
    labelPermitNumber: 'N° de permis',
    labelCode: "Code d'accès",
    formTitle: 'Veuillez entrer les informations qui vous ont été envoyées.',
    messageActivationError: `Ce code n'est pas valide.`,
    messageActivationSuccess: 'Vous avez maintenant accès au permis.',
  },
  permitHolder: {
    select: 'Choisissez le détenteur de permis',
  },
  producer: {
    select: 'Choisissez le producteur',
    title: 'Producteurs',
  },
  regulationDateLimit: {
    add: `Ajouter une date d'affichage`,
    ANNUAL: 'Configuration annuelle',
    edit: `Modifier une date d'affichage`,
    GLOBAL: 'Configuration globale',
    title: `Date d'affichage des déclarations`,
    type: {
      GLOBAL: 'Globale',
      ANNUAL: 'Annuelle',
    },
    month: `Mois affichage année suivante`,
    day: `Jour affichage année suivante`,
  },
  requestStatus: {
    ACCEPTED: 'Acceptée',
    CANCELED: 'Annulée',
    CANCELED_OWNER_CHANGE: 'Annulée - Changement de propriétaire',
    CANCELED_ERROR: 'Annulée - Erreur',
    CANCELED_BY_OWNER: 'Annulée - Par le propriétaire de la demande',
    CANCELED_REMOVED_CONSENT: 'Annulée - Retrait de consentement',
    CANCELED_REMOVED_CONSENT_BY_ORG: `Annulée - Retrait de consentement via l'association`,
    IN_PROGRESS: 'En analyse',
    REFUSED: 'Refusée',
    SENT: 'Transmise',
  },
  requestStatusDetail: {
    ERROR: 'Erreur',
    OWNER_CHANGE: 'Changement de propriétaire',
    BY_OWNER: `Par le propriétaire de la demande`,
    REMOVED_CONSENT: `Retrait de consentement`,
    REMOVED_CONSENT_BY_ORG: `Retrait de consentement via l'association`,
  },
  routeOfAdministration: {
    add: {
      success: `La voie d'administration à été ajoutée avec succès.`,
      title: `Ajouter une voie d'administration`,
    },
    edit: {
      error: `La mise à jour de la voie d'administration a échoué.`,
      success: `La voie d'administration à été mise à jour avec succès.`,
      title: `Modifier une voie d'administration`,
    },
    list: `Liste des voies d'administration`,
    remove: `Retirer la voie d'administration`,
    title: `Voies d'administration`,
  },
  site: {
    add: 'Ajouter un site',
    addNew: 'Ajouter un site non mémorisé',
    edit: 'Modifier le site',
    remove: 'Retirer le site',
    selectMulti: 'Choisir les sites',
    title: 'Sites',
  },
  species: {
    labelOfficialSite: 'Numéro de site règlementé',
    labelCanHaveSite: 'Peut avoir un site',
    select: `Choisissez l'espèce`,
    selectMulti: `Choisissez les espèces`,
    title: 'Espèces',
    titleFormAdd: 'Ajouter une espèce',
    titleFormEdit: 'Modifier une espèce',
    messageAddSuccess: "L'espèce a été ajoutée avec succès.",
    messageEditSuccess: "L'espèce a été modifiée avec succès.",
    messageDeleteSuccess: "L'espèce a été supprimée avec succès.",
    messageActivatedSuccess: 'Les espèces ont été activées avec succès.',
    messageDeactivatedSuccess: 'Les espèces ont été désactivées avec succès.',
  },
  statistics: {
    title: {
      activeIngredientQtyPerAntibiotic: `Quantité annuelle totale (en kg) d'antibiotiques achetés`,
      activeIngredientQtyPerAntibioticCategory: `Quantité annuelle totale (en kg) d'antibiotiques achetés par catégorie d'importance en médecine humaine`,
      activeIngredientQtyPerAntibioticFamily: `Quantité annuelle totale (en kg) d'antibiotiques achetés par famille`,
      activeIngredientQtyPerMedicationType: `Quantité d'ingrédients actifs par type de médicament`,
      activeIngredientQtyVersusOthers: `Quantité totale d'ingrédients actifs par rapport aux autres`,
      dashboard: 'Tableau de bord',
      prescriptionSummary: 'Résumé des ordonnances exécutées',
      purchaseSummary: 'Résumé des achats',
    },
    label: {
      activeIngredientAction: `Action de l'ingrédient actif`,
      activeIngredientQty: `Quantité d'ingrédient actif (kg)`,
      antibiotic: 'Antibiotique',
      antibioticCategory: `Catégorie d'antibiotique`,
      antibioticFamily: `Famille d'antibiotique`,
      antibioticFamilyPerYear: `Famille d'antibiotique par année`,
      antibioticPerYear: 'Antibiotique par année',
      antibioticQuantity: `Quantité totale d'antibiotiques (en kg)`,
      declarationPercentage: '% de déclarations',
      declarationSpeciesWithSitePercentage: `% de déclarations avec un numéro de site pour l'espèce "{species}"`,
      declarationSpeciesWithoutSitePercentage: `% de déclarations sans numéro de site pour l'espèce "{species}"`,
      declarationSpeciesWithSiteQty: `Nombre de déclarations avec un numéro de site pour l'espèce "{species}"`,
      declarationSpeciesWithoutSiteQty: `Nombre de déclarations sans numéro de site pour l'espèce "{species}"`,
      declarationTotalQty: 'Nombre total de déclarations',
      declarationWithSitePercentage: '% de déclarations avec un numéro de site',
      declarationWithoutSitePercentage: '% de déclarations sans numéro de site',
      filterBlock: `Les critères choisis s'appliqueront à l'ensemble des graphiques et tableaux du rapport.`,
      importanceLevel: `Catégorie d'importance`,
      importanceLevels: {
        title: `Catégorie d'importance en médecine humaine`,
        l1: 'I : Très haute importance',
        l2: 'II : Haute importance',
        l3: 'III : Importance moyenne',
        l4: 'IV : Faible importance',
      },
      numberOfDeclarations: 'Nombre de déclarations',
      permitNumber: 'Numéro de permis',
      productQty: 'Quantité de produit (kg)',
      purchasedProduct: 'Produit acheté',
      purchaseSummary: {
        detailsAccordion: 'Précisions sur certaines notions du tableau.',
        filterBlock: `{br}Les données du tableau s'adapteront aux critères sélectionnés.`,
        lockedTooltip: 'Donnée masquée',
      },
      purchaseYear: `Année de l'achat`,
      saleYear: 'Année de la vente',
      totalQuantity: `Quantité totale`,
      transactionDate: 'Date de transaction',
      transmissionDate: `Date de transmission`,
      detailsAccordion: `Précisions sur certaines notions du rapport.`,
      siteNumber: 'Numéro de site',
      siteNumberQc: 'Numéro de site QC',
      sites: 'Sites',
      veterinarians: 'Vétérinaires',
    },
    filter: {
      allCategories: 'Toutes',
    },
    admin: {
      permitholderTitle: 'Tableau de bord des détenteurs de permis',
      producerTitle: 'Rapport individuel confidentiel du producteur (version préliminaire)',
      veterinarianTitle: 'Tableau de bord des vétérinaires',
      organizationTitle: 'Tableau de bord des associations',
    },
    declaration: {
      pendingTitle: '{count,plural,one{Déclaration}other{Déclarations}} en attente',
      transmittedTitle: '{count,plural,one{Déclaration transmise}other{Déclarations transmises}}',
      transmittedNoPermitTitle:
        '{count,plural,one{Déclaration transmise}other{Déclarations transmises}} sans n° de permis',
      transmittedNoPermitDescription:
        "Il est nécessaire d'ajouter un numéro de permis relatif aux prémélanges médicamenteux et aliments médicamenteux à {count} {count,plural,one{déclaration transmise}other{déclarations transmises}}. Un prémélange médicamenteux ne peut être vendu ou fourni qu'à un détenteur de permis relatif aux prémélanges médicamenteux et aliments médicamenteux.",
      transmittedNoTraceabilityNumberTitle:
        '{count,plural,one{Déclaration transmise}other{Déclarations transmises}} sans n° de traçabilité du site.',
      transmittedNoTraceabilityNumberDescription:
        "Vous avez transmis {count} {count,plural,one{déclaration pour laquelle}other{déclarations pour lesquelles}} un numéro de traçabilité du site (SimpliTRACE, PorcTRACÉ ou un numéro de poulailler) aurait pu être renseigné. Cette donnée est nécessaire pour un retour d'information efficace à vos clients. SVP modifiez les déclarations concernées.",
      allDeclarationsCount: 'Nombre total de déclarations',
      declarationsWithSiteNumber: 'Nombre de déclarations avec un numéro de site',
      declarationsWithoutSiteNumber: 'Nombre de déclarations sans numéro de site',
    },
    organization: {
      registeredOwnersDeclarationsIndicator: `Nombre de propriétaires`,
      registeredOwnersDeclarationsSubtitle: `Présentation des propriétaires d'animaux consentants ayant au moins une déclaration transmise par un établissement vétérinaire.`,
      registeredOwnersDeclarationsTitle: `Transmission de déclarations vétérinaires au niveau des propriétaires d'animaux`,
      registeredPetOwnersIndicator: `Nombre de propriétaires d'animaux inscrits`,
      registeredPetOwnersSubtitle: `Présentation des propriétaires d'animaux participant à la portion volontaire du monitorage.`,
      registeredPetOwnersTitle: `Consentements des propriétaires d'animaux`,
      registeredSitesIndicator: `Nombre de sites inscrits`,
      registeredSitesSubtitle:
        'Présentation des sites de propriétaires participants à la portion volontaire du monitorage.',
      registeredSitesTitle: `Consentements au niveau des sites`,
      registrationStatusesTitle: `Statut des inscriptions`,
    },
    producer: {
      declarationTypePerMedicationType: {
        subtitle: `Une déclaration concerne une vente ou fourniture (représentée dans un dégradé bleu selon les années) ou un retour (représenté en bleu clair).`,
        title: 'Déclarations par type de médicament et combinaison de types de médicaments',
      },
      dashboard: {
        title: `Rapport individuel confidentiel (version préliminaire)`,
        info1: `Le modèle de rapport du producteur est en construction. Cette première version affiche les quantités brutes
        d'antibiotiques contenus dans les prémélanges et aliments médicamenteux que vous avez achetés.
        Il est prévu, dans une prochaine version, de standardiser ces quantités sur un nombre d'animaux afin d'éventuellement
        permettre une comparaison confidentielle de vos sites avec des sites de production similaires.{br}{br}
        Le système de monitorage étant récent, il est possible que des erreurs subsistent dans les données transmises à AntibiotiQC, malgré les vérifications effectuées.
        Si vous constatez ou suspectez une anomalie (p. ex. achats manquants ou en trop, quantités erronées, etc.), veuillez communiquer avec le <requestManagementLink>Service à la clientèle d'Attestra</requestManagementLink>.
      `,
        info2: `Ce rapport résume les données d'achats de prémélanges et d'aliments médicamenteux se rapportant aux sites de production hébergeant vos animaux.
        Ces données sont recueillies auprès des meuneries préparatrices et distributrices dans le cadre du Règlement sur les prémélanges médicamenteux et aliments médicamenteux destinés aux animaux (Chapitre P-42, r. 10).`,
        info3: `Dans ce rapport :`,
        info4: `<ul>
        <li-sm>Les antibiotiques réfèrent aux médicaments ayant une action contre les bactéries, alors que les antiparasitaires
        réfèrent aux médicaments agissant contre les parasites internes et externes.</li-sm>
        <li-sm>Les molécules de la famille des ionophores agissent contre les bactéries et contre certains parasites. Elles sont donc
        à la fois considérées comme des antibiotiques et des antiparasitaires.</li-sm>
        <li-sm>Les antibiotiques sont catégorisés selon leur importance en médecine humaine telle que définie par Santé Canada :
        de très haute importance pour la catégorie I à faible importance pour la catégorie IV qui inclut les antibiotiques seulement utilisés en médecine vétérinaire.
        <healthLink>Catégorisation des médicaments antimicrobiens basée sur leur importance en médecine humaine</healthLink>.</li-sm>
        </ul>`,
      },
      purchaseSummary: {
        info1: `Le système de monitorage étant récent, il est possible que des erreurs subsistent dans les données transmises à AntibiotiQC, malgré les vérifications effectuées.
          Si vous constatez ou suspectez une anomalie (p. ex. achats manquants ou en trop, quantités erronées, etc.), veuillez communiquer avec le <requestManagementLink>Service à la clientèle d'Attestra</requestManagementLink>.`,
        info2: `Ce tableau présente une synthèse de vos achats d'antibiotiques contenus dans les prémélanges et aliments médicamenteux. Chaque ligne regroupe donc vos achats par produit et médicament commercial achetés auprès d’une même meunerie et destinés à un site de production.
          Ces données sont recueillies auprès des meuneries préparatrices et distributrices dans le cadre du Règlement sur les prémélanges médicamenteux et aliments médicamenteux destinés aux animaux (Chapitre P-42, r. 10).`,
        info3: `Dans ce tableau :`,
        info4: `<ul>
          <li-sm>Les antibiotiques réfèrent aux médicaments ayant une action contre les bactéries, alors que les antiparasitaires réfèrent aux médicaments agissant contre les parasites internes et externes.</li-sm>
          <li-sm>Les molécules de la famille des ionophores agissent contre les bactéries et contre certains parasites. Elles sont donc à la fois considérées comme des antibiotiques et des antiparasitaires.</li-sm>
          <li-sm>Les antibiotiques sont catégorisés selon leur importance en médecine humaine telle que définie par Santé Canada :
          de très haute importance pour la catégorie I à faible importance pour la catégorie IV qui inclut les antibiotiques seulement utilisés en médecine vétérinaire.
          <healthLink>Catégorisation des médicaments antimicrobiens basée sur leur importance en médecine humaine</healthLink>.</li-sm>
          <li-sm>Un ingrédient actif est une substance composant un médicament et ayant un effet pharmaceutique.</li-sm>
          </ul>`,
        tablePlaceholder:
          'Tableau à brancher : afficher ici la synthèse des achats (groupés par produit, médicament, meunerie et site).',
      },
    },
    veterinarian: {
      activeIngredientQtyPerAntibiotic: {
        title: `Quantité annuelle totale (en kg) d'antibiotiques achetés par votre clientèle, dont vous êtes le prescripteur`,
      },
      activeIngredientQtyPerAntibioticCategory: {
        title: `Quantité annuelle totale (en kg) d'antibiotiques achetés par votre clientèle, dont vous êtes le prescripteur, par catégorie d'importance en médecine humaine`,
      },
      activeIngredientQtyPerAntibioticFamily: {
        title: `Quantité annuelle totale (en kg) d'antibiotiques achetés par votre clientèle, dont vous êtes le prescripteur, par famille`,
      },
      dashboard: {
        title: `Rapport individuel confidentiel (version préliminaire)`,
        info1: `Le modèle de rapport vétérinaire est en construction. Cette première version affiche les quantités brutes d'antibiotiques vendus par les meuneries dont vous étiez le prescripteur.
          Il est prévu, dans une prochaine version, de standardiser les quantités d'antibiotiques sur un nombre d'animaux afin d'éventuellement permettre une comparaison confidentielle de vos pratiques de prescription avec celles de vos pairs.{br}{br}
          Le système de monitorage étant récent, il est possible que des erreurs subsistent dans les données transmises à AntibiotiQC, malgré les vérifications effectuées.
          Si vous constatez ou suspectez une anomalie (p. ex. des antibiotiques manquants ou présence d'un antibiotique non prescrit, quantités erronées, etc.), veuillez communiquer avec le <requestManagementLink>Service à la clientèle d'Attestra</requestManagementLink>.`,
        info2: `Ce rapport résume les données d'achats de prémélanges et d'aliments médicamenteux se rapportant aux sites de production de votre clientèle pour lesquelles vous êtes identifié comme le médecin vétérinaire prescripteur.
        Ces données sont recueillies auprès des meuneries préparatrices et distributrices dans le cadre du Règlement sur les prémélanges médicamenteux et aliments médicamenteux destinés aux animaux (Chapitre P-42, r. 10).`,
        info3: `Dans ce rapport :`,
        info4: `<ul><li-sm>Les catégories d'importance en médecine humaine sont celles définies par <healthLink>Santé Canada</healthLink>.</li-sm></ul>`,
      },
      prescriptionSummary: {
        info1: `Le système de monitorage étant récent, il est possible que des erreurs subsistent dans les données transmises à AntibiotiQC, malgré les vérifications effectuées.
          Si vous constatez ou suspectez une anomalie (p. ex. des antibiotiques manquants ou présence d'un antibiotique non prescrit, quantités erronées, etc.), veuillez communiquer avec le <requestManagementLink>Service à la clientèle d'Attestra</requestManagementLink>.`,
        info2: `Ce tableau présente une synthèse des données d'achats d'antibiotiques contenus dans les prémélanges et aliments médicamenteux se rapportant
          aux sites de production de votre clientèle pour lesquels vous êtes identifié comme le médecin vétérinaire prescripteur. Chaque ligne regroupe les achats par produit et médicament commercial achetés.
          Ces données sont recueillies auprès des meuneries préparatrices et distributrices dans le cadre du Règlement sur les prémélanges médicamenteux et aliments médicamenteux destinés aux animaux (Chapitre P-42, r. 10).`,
        info3: `Dans ce tableau :`,
        info4: `<ul><li-sm>Les catégories d'importance en médecine humaine sont celles définies par <healthLink>Santé Canada</healthLink>.</li-sm></ul>`,
        info5: `Les données du tableau s'adapteront aux critères sélectionnés.`,
      },
    },
    excel: {
      activeIngredientQtyPerAntibioticCategory: {
        year: `Année de l'achat`,
        ingredient_actif_total_kg: `Quantité d'ingrédient actif (kg)`,
        ingredient_actif_antibiotic_category: `Catégorie d'importance`,
      },
      activeIngredientQtyPerAntibioticFamily: {
        year: `Année de l'achat`,
        ingredient_actif_antibiotic_family_fr: `Famille d'antibiotique`,
        ingredient_actif_total_kg: `Quantité d'ingrédient actif (kg)`,
        ingredient_actif_antibiotic_category: `Catégorie d'importance`,
      },
      activeIngredientQtyPerAntibiotic: {
        year: `Année de l'achat`,
        ingredient_actif_antibiotic_name_fr: 'Antibiotique',
        ingredient_actif_total_kg: `Quantité d'ingrédient actif (kg)`,
        ingredient_actif_antibiotic_category: `Catégorie d'importance`,
      },
      purchaseSummaryTable: {
        permit_permit_number: 'Fournisseur',
        site_number: 'Numéro de site QC',
        product_name: 'Produit acheté',
        sum_product_qty: 'Quantité de produit (kg)',
        medication_name: 'Médicament commercial',
        active_ingredient_name: 'Ingrédient actif',
        ingredient_actif_total_kg: `Quantité d'ingrédient actif (kg)`,
        medication_type: `Action de l'ingrédient actif`,
        family: `Famille d'antibiotique`,
        category: `Catégorie d'antibiotique`,
      },
      prescriptionSummaryTable: {
        year: 'Année de la vente',
        product_name: 'Produit acheté',
        sum_product_qty: 'Quantité de produit (kg)',
        medication_name: 'Médicament commercial',
        active_ingredient_name: 'Ingrédient actif',
        ingredient_actif_total_kg: `Quantité d'ingrédient actif (kg)`,
        family: `Famille d'antibiotique`,
        category: `Catégorie d'antibiotique`,
        medication_type: `Action de l'ingrédient actif`,
      },
    },
  },
  user: {
    title: 'Utilisateurs',
    titleFormAdd: 'Ajouter un utilisateur',
    titleFormEdit: 'Modifier un utilisateur',
    messageAddSuccess: "L'utilisateur a été ajouté avec succès.",
    messageEditSuccess: "L'utilisateur a été modifié avec succès.",
    messageDeleteSuccess: "L'utilisateur a été supprimé avec succès.",
    messageActivatedSuccess: 'Les utilisateurs ont été activés avec succès.',
    messageDeactivatedSuccess: 'Les utilisateurs ont été désactivés avec succès.',
    labelName: 'Nom',
    labelEmail: 'Courriel',
    labelPhone: 'Téléphone',
    labelLanguage: 'Langue',
    labelRole: 'Rôle',
    errorRole: 'Vous devez entrer au moins 1 rôle',
    roles: {
      ROLE_USER: 'Utilisateur',
      ROLE_ADMIN: 'Administrateur',
      ROLE_SUPPORT: 'Support technique',
      ROLE_SUPPORT_RO: 'Opérateur (service à la clientèle)',
      ROLE_MAPAQ: 'MAPAQ (Pilotage)',
      ROLE_MAPAQ_RO: 'MAPAQ (Lecture seule)',
      ROLE_DETENTEUR_PERMIS: 'Détenteur de permis',
      ROLE_VET: 'Vétérinaire',
      ROLE_PRODUCER: 'Producteur',
      ROLE_ASSOCIATION: 'Association',
      ROLE_FMV: 'Faculté de médecine vétérinaire',
      ROLE_VET_SOFTWARE_SUPPLIER: 'Fournisseur logiciel de vet',
    },
    labelConsentCommunication: 'Communication Attestra/MAPAQ',
    consentCommunication: {
      authorized: 'Autorisée',
      nonAuthorized: 'Non autorisée',
    },
    labelStatus: 'Statut',
    profileTitle: `Détails du profil de l'utilisateur`,
    changeEmail: 'Modifier',
    changeEmailTitle: 'Modifier votre courriel',
    changeEmailNewEmail: 'Nouveau courriel',
    changeEmailSend: 'Envoyer',
    changeEmailVerifyTitle: 'Vérifier votre courriel',
    changeEmailCodeSent: 'Un code de vérification a été envoyé à {email}.',
    changeEmailCode: 'Code de vérification',
    changeEmailSuccess: 'Votre courriel a été modifié avec succès.',
    changeEmailInvalidCode: 'Code invalide ou expiré.',
    changeEmailEmailRequired: 'Le courriel est requis.',
    changeEmailEmailInvalid: 'Format de courriel invalide.',
    changeEmailCodeRequired: 'Le code est requis.',
    changeEmailSuccessTitle: 'Courriel changé avec succès',
    changeEmailSuccessMessage: 'Votre adresse courriel a été changée avec succès.',
    changeEmailReloginRequired:
      'Veuillez vous reconnecter avec votre nouveau courriel pour continuer.',
    status: {
      INACTIVE: 'Inactif',
      ACTIVE: 'Actif',
      PENDING_ACTIVATION: 'En attente',
    },
  },
  userConsent: {
    authorization: 'Autorisation',
    authorized: {
      checked: `L'autorisation a été accordée avec succès.`,
      error: `Impossible de changer l'autorisation. Veuillez essayer plus tard.`,
      unchecked: `L'autorisation a été retirée avec succès.`,
    },
    MAPAQ_COMMS: {
      confirm: `Acceptez-vous que le MAPAQ ou son mandataire Attestra utilise votre adresse courriel pour vous transmettre de l’information concernant AntibiotiQC ou concernant le projet de monitorage de l’utilisation des antibiotiques en santé animale au Québec?`,
      confirmProducer: `Acceptez-vous qu'Attestra utilise votre adresse courriel pour vous transmettre de l’information concernant AntibiotiQC ou concernant le projet de monitorage de l’utilisation des antibiotiques en santé animale au Québec?`,
      confirmVeterinarian: `Acceptez-vous qu'Attestra utilise votre adresse courriel pour vous transmettre de l’information concernant AntibiotiQC ou concernant le projet de monitorage de l’utilisation des antibiotiques en santé animale au Québec?`,
    },
    info: `Le MAPAQ ou son mandataire Attestra pourraient utiliser votre adresse courriel pour vous transmette de l’information concernant AntibiotiQC ou concernant le projet de monitorage de l’utilisation des antibiotiques en santé animale. Il est à noter que pour tout ce qui concerne l’application du Règlement sur les prémélanges médicamenteux et les aliments médicamenteux destinés aux animaux (P-42, r.10) et la gestion des permis associés, ce sont les coordonnées fournies dans le dossier d’enregistrement du permis au MAPAQ qui doivent être utilisées pour les communications entre le MAPAQ et le détenteur de permis.`,
  },
  userMenu: {
    darkMode: 'Mode sombre',
    lightMode: 'Mode clair',
    profile: 'Profil',
    settings: 'Préférences',
    viewProfile: 'Visualiser mon profil',
  },
  useTerm: {
    accept: `J'accepte les conditions d'utilisation.`,
    accepted: `Vous avez accepté les conditions d'utilisation.`,
    read: `Lire les conditions`,
    required: `Vous devez accepter les conditions d'utilisation.`,
    title: `Conditions d'utilisation`,
  },
  veterinarian: {
    select: 'Choisissez le vétérinaire',
  },
  Unknown: 'Non défini',
  chooseSelectLabel: 'Choisissez',
  loading: 'Chargement',
  yes: 'Oui',
  no: 'Non',
  debug_section_title: 'Section de Debug',
  debug_create_fe_error: 'Créer une erreur Front End',
  debug_create_be_error: 'Créer une erreur Back End',
  deletion: 'Suppression',
  deletionGenericMessage: "Voulez-vous vraiment supprimer l'item?",
  deletionGenericMessageMultiple: 'Voulez-vous vraiment supprimer les items?',
  or: 'ou',
  pageLoaderLabel: 'Chargement en cours.',
  clickHere: 'Cliquez ici',
  declarationStepper_stepVeterinary_emptyRecentMostUsedListLabel:
    'Aucun médecin vétérinaire trouvé.',
  search: 'Rechercher',
  declarations_productionSite_sitePermitNumber: 'N° de permis {sitePermitNumber}',
  declarations_productionSite_siteNumber: 'N° de site {siteNumber}',
  declarations_veterinaire_licence_notValid:
    "Le numéro de permis d'exercice doit être composé de 4 chiffres.",
  declarationEmbeddedTable_createdBy: 'Créé par',
  declarations_dropdownMenu_duplicate: 'Dupliquer une déclaration',
  declarations_menu_button_duplicate: 'Dupliquer',
  declarations_dropdownMenu_duplicate_hint:
    ' Veuillez choisir le même client et permis déclarant pour dupliquer une déclaration.',
  declarations_dropdownMenu_delete: 'Supprimer',
  declarations_dropdownMenu_saveModel: 'Sauvegarder comme modèle',
  declarations_dropdownMenu_saveModel_hint:
    ' Veuillez choisir le même client et permis déclarant pour créer un modèle.',
  declarations_dropdownMenu_duplicate_saveModel_hint:
    'Veuillez choisir le même client et permis déclarant pour créer un modèle ou dupliquer des déclarations.',
  all_choose: 'Choisir',
  systemBase: {
    back: 'Annuler',
    languages: {
      fr: 'Français',
      en: 'English',
    },
    prevStep: 'Précédent',
    showNotification: {
      systemMessageLabel: 'Message du système',
      serverValidationFailed: 'Erreur de validation au serveur.',
    },
    tableLister: {
      deleteSelection: 'Supprimer',
      deleteText: 'Les éléments sélectionnés seront supprimés, voulez-vous continuer?',
      deleteSelectionMessage: 'Êtes-vous certain de vouloir supprimer les items sélectionnés?',
      labelActions: 'Actions',
      labelDesactiver: 'Désactiver',
      labelDesactiverConfirmed: 'Êtes-vous certain de vouloir désactiver?',
      labelActiver: 'Activer',
      labelActiverConfirmed: 'Êtes-vous certain de vouloir activer?',
      labelMenuPopupSearch: 'Recherche',
      labelMenuPopupApp: 'Application',
      labelMenuPopupItemSelected: 'Items sélectionnés',
    },
  },
  home: {
    title: 'Bienvenue sur AntibiotiQC',
    copyright: `© Gouvernement du Québec ({year}) - Reproduit sous licence`,
    faq: {
      api: {
        title: `Transmission des données`,
        text1_prod: `Avis aux intervenants responsables de la transmission de données : avant la transmission officielle,
          il est recommandé d'effectuer des tests dans l'environnement de préproduction en utilisant uniquement des données dépersonnalisées
          (ex. : noms de clients fictifs). Veuillez noter que cet environnement peut être temporairement inaccessible. Pour obtenir un compte
          et accéder à l'environnement de préproduction, contactez le <requestManagementLink>Service à la clientèle d'Attestra</requestManagementLink>.`,
        doc: `Consultez la <apiLink>documentation pour la transmission par API</apiLink>.`,
        info: `Pour plus d'information, communiquez avec l'équipe du monitorage au MAPAQ <mapaqMailTo>AntibiotiQC@mapaq.gouv.qc.ca</mapaqMailTo>.`,
        method_dev: `Pour effectuer vos tests de transmission de données, veuillez utiliser l'une ou l'autre des méthodes disponibles selon votre profil d'utilisateur.`,
        method_prod: `Lorsque vous serez prêt à transmettre officiellement vos données, veuillez utiliser l'une ou l'autre des méthodes disponibles selon votre profil d'utilisateur.`,
        permit_t1: `Détenteurs de permis relatifs aux prémélanges médicamenteux et aux aliments médicamenteux`,
        permit_l1: `Interface API (en anglais, Application Programming Interface);`,
        permit_l2: `Formulaire Web de saisie manuelle.`,
        permit_t2: `Consultez la <monitoringLink>documentation sur les données à transmettre au MAPAQ</monitoringLink>.`,
        vet_t1: `Associations de producteurs et établissements vétérinaires`,
        vet_l1: `Interface API (en anglais, Application Programming Interface).`,
      },
      info: {
        title: `Informations supplémentaires`,
        mapaqMonitoringLink: `Système de monitorage de l'utilisation des antibiotiques`,
      },
      monitoring: {
        title: `Producteurs et médecins vétérinaires`,
        text1: `AntibiotiQC permet aux associations de producteurs et aux établissements vétérinaires de transmettre des données dans le cadre du volet volontaire du monitorage,
          pour les propriétaires d'élevages d'animaux de consommation qui le consentent. Un secteur de production à la fois est intégré au volet volontaire, en commençant avec le secteur porcin.`,
        text2: `Les producteurs peuvent consulter un rapport individuel et confidentiel sur les antibiotiques achetés pour utilisation sur leurs sites de production.
          Ils ont aussi la possibilité de rendre ce rapport disponible à leur médecin vétérinaire traitant.`,
        text3: `Les médecins vétérinaires pratiquant dans le secteur bioalimentaire peuvent consulter un rapport individuel confidentiel
          sur les ventes d'antibiotiques associées à leur permis d'exercice et les rapports de monitorage de leurs clients, lorsque ces derniers en ont autorisé la consultation.`,
      },
      permit: {
        title: `Détenteurs de permis relatifs aux prémélanges médicamenteux et aliments médicamenteux`,
        antibioLink: `Règlementation sur l'utilisation des antibiotiques chez les animaux`,
        legisLink: `Règlement sur les prémélanges médicamenteux et les aliments médicamenteux destinés aux animaux (Chapitre P-42, r.10)`,
        text1: `AntibiotiQC permet aux détenteurs de permis de transmettre les registres des ventes et des fournitures dans le cadre du Règlement
          sur les prémélanges médicamenteux et les aliments médicamenteux destinés aux animaux (Chapitre P-42, r.10).
          Les détenteurs de permis contribuent au volet réglementaire du système de monitorage.`,
      },
      support: {
        title: `Soutien aux utilisateurs`,
        text1: `Si vous avez des questions concernant le fonctionnement de la plateforme AntibiotiQC ou si vous éprouvez des difficultés techniques lors de son utilisation, nous vous invitons à communiquer avec un agent du Service à la clientèle :`,
        list1: `via le <requestManagementLink>portail en ligne de gestion des demandes</requestManagementLink>;`,
        list2: `en laissant un message sur la boîte vocale au 438 222-1311 ou, sans frais, au 1 866 220-7115.`,
        text2: `Pour les questions relatives à l'application règlementaire ou pour toute autre question, communiquez avec l'équipe du monitorage au MAPAQ en écrivant à <mapaqMailTo>AntibiotiQC@mapaq.gouv.qc.ca</mapaqMailTo>.`,
      },
      training: {
        title: `Ressources d'aide et de formation`,
        text1: `Accédez aux <trainingLink>guides et tutoriels</trainingLink> pour vous familiariser avec l'utilisation de la plateforme AntibiotiQC.`,
        text2: `Consultez la <faqLink>foire aux questions</faqLink> pour trouver rapidement des réponses aux questions les plus courantes.`,
      },
    },
    text1: `AntibiotiQC, développée et gérée par Attestra, est la plateforme de monitorage de l'utilisation des antibiotiques en santé animale au Québec du ministère de l'Agriculture, des Pêcheries et de l'Alimentation (MAPAQ).`,
    text2: `
      Vous vous trouvez actuellement dans l'environnement de préproduction.
      Il est recommandé d'y effectuer des tests en utilisant uniquement des données dépersonnalisées (ex. : noms de clients fictifs) avant la transmission officielle des données dans l'environnement de production.
      Veuillez noter que cet environnement peut être temporairement inaccessible. Pour obtenir un compte, contactez le <requestManagementLink>Service à la clientèle d'Attestra</requestManagementLink>.
    `,
    text3: `
      Pour obtenir un compte utilisateur dans l'environnement de test préproduction, contactez le <customerLink>soutien technique d'Attestra</customerLink>.
      Cet environnement vous permet de réaliser des tests en prenant soin d'indiquer des données dépersonnalisées (ex. : noms de clients fictifs). Il peut être temporairement inaccessible.
    `,
  },
  signupSSOAccountExistenceConfirmation: {
    question: "Avez-vous un compte Service d'authentification / AntibioQC?",
    answerYes: 'Oui',
    answerNo: 'Non',
  },
  signup: {
    title: 'Inscription!',
  },
  signupConfirm: {
    welcome:
      "Bienvenue sur la plateforme AntibiotiQC.  Veuillez procéder à la confirmation de votre identité en saisissant le code reçu à l'adresse courriel d'inscription dans le champ prévu à cet effet ci-dessous.",
    enterCode: 'Saisir le code',
  },
  signup_recaptchaFailed: "L'inscription a échoué.",
  formErrorBase: {
    required: 'Ce champ est obligatoire',
    validNumber: 'Veuillez saisir un nombre',
    positiveNumber: 'Veuillez saisir un nombre positif',
    integer: 'Veuillez saisir un nombre entier',
    maxLength255: 'Ce champ est limité à un maximum de 255 caractères',
    maxLength100: 'Ce champ est limité à un maximum de 100 caractères',
    maxLength50: 'Ce champ est limité à un maximum de 50 caractères',
    maxLength25: 'Ce champ est limité à un maximum de 25 caractères',
    maxLength20: 'Ce champ est limité à un maximum de 20 caractères',
    maxLength15: 'Ce champ est limité à un maximum de 15 caractères',
    maxLength10: 'Ce champ est limité à un maximum de 10 caractères',
    maxNumber4: 'Ce champ est limité à un maximum de 4 chiffres',
    maxNumber5: 'Ce champ est limité à un maximum de 5 chiffres',
    minNumber2: 'Ce champ est doit avoir un minimum de 2 chiffres',
    postalCode: 'Le code postal doit être entré selon le format suivant : X0X 0X0',
    postalCode_CA: 'Le code postal doit être entré selon le format suivant : X0X 0X0',
    postalCode_US:
      'Le code postal doit être entré selon un des deux formats suivants : 12345 ou 12345-6789',
    postalCode_null: 'Impossible de valider le code postal, le pays est absent',
    postalCode_undefined: 'Impossible de valider le code postal, le pays est absent',
    email: "L'adresse courriel doit être valide",
    phone: 'Le numéro de téléphone doit être valide',
    passwordMin: 'Le mot de passe doit contenir un minimum de 14 caractères',
    acceptTerms: "Vous devez cocher la case afin d'accepter les termes et conditions",
  },
  formErrorBase_endDateGreatherThanStartDate:
    'La date de fin doit être postérieure à la date de début',
  typeBase: {
    labelName: 'Nom',
    labelNameFr: 'Nom français',
    labelNameEn: 'Nom anglais',
    labelCode: 'Code',
    labelActive: 'Actif',
    labelBtnSave: 'Enregistrer',
    labelBtnAdd: 'Ajouter',
    productType: 'Type de produit',
    medicationType: 'Type de médicament',
    species: 'Espèces',
    productionStageGroup: 'Regroupement',
    animalCategory: "Catégorie animale",
    product: 'Produits',
    badgeLabelActive: 'Actif',
    badgeLabelInactive: 'Inactif',
    cancelConfirmDirtyForm: 'Les informations non sauvegardées seront perdues',
    labelBtnCancel: 'Annuler',
    labelBtnCancelConfirm: 'Êtes-vous certain de vouloir supprimer? ',
    labelBtnConfirm: 'Confirmer',
    LabelBtnResetFilter: 'Réinitialiser les filtres',
    LabelBtnResetSort: 'Réinitialiser les tris',
    messageActivatedSuccess: 'Les items ont été activés avec succès.',
    messageDeactivatedSuccess: 'Les items ont été désactivés avec succès.',
    messageEditSuccess: "L'item a été modifié avec succès.",
  },
  typeBase_labelActive: 'Statut',
  typeBase_badgeLabelActive: 'Actif',
  typeBase_badgeLabelInactive: 'Inactif',
  typeBase_statusDate: 'Date du statut',
  typeBase_createdAt: 'Date de création',
  productType: {
    title: 'Types de produits',
    titleFormAdd: 'Ajouter un type de produit',
    titleFormEdit: 'Modifier un type de produit',
    messageAddSuccess: 'Le type de produit a été ajouté avec succès.',
    messageEditSuccess: 'Le type de produit a été modifié avec succès.',
    messageDeleteSuccess: 'Le type de produit a été supprimé avec succès.',
    messageActivatedSuccess: 'Les types de produits ont été activés avec succès.',
    messageDeactivatedSuccess: 'Les types de produits ont été désactivés avec succès.',
  },
  product: {
    title: 'Produits',
    titleFormAdd: 'Ajouter un produit',
    titleFormEdit: 'Modifier un produit',
    messageAddSuccess: 'Le produit a été ajouté avec succès.',
    messageEditSuccess: 'Le produit a été modifié avec succès.',
    messageDeleteSuccess: 'Le produit a été supprimé avec succès.',
    messageActivatedSuccess: 'Les produits ont été activés avec succès.',
    messageDeactivatedSuccess: 'Les produits ont été désactivés avec succès.',
  },
  medicationType: {
    title: 'Types de médicaments',
    titleFormAdd: 'Ajouter un type de médicament',
    titleFormEdit: 'Modifier un type de médicament',
    messageAddSuccess: 'Le type de médicament a été ajouté avec succès.',
    messageEditSuccess: 'Le type de médicament a été modifié avec succès.',
    messageDeleteSuccess: 'Le type de médicament a été supprimé avec succès.',
    messageActivatedSuccess: 'Les types de médicament ont été activés avec succès.',
    messageDeactivatedSuccess: 'Les types de médicament ont été désactivés avec succès.',
  },
  animalCategory: {
    title: `Catégories animales`,
    titleFormAdd: "Ajouter une catégorie animale",
    titleFormEdit: "Modifier une catégorie animale",
    messageAddSuccess: "La catégorie animale a été ajoutée avec succès.",
    messageEditSuccess: "La catégorie animale a été modifiée avec succès.",
    messageDeleteSuccess: "La catégorie animale a été supprimée avec succès.",
    messageActivatedSuccess: "Les catégories animale ont été activées avec succès.",
    messageDeactivatedSuccess: "Les catégories animale ont été désactivées avec succès.",
  },
  medicationFormError_dimNumberFormat:
    "Le numéro d'identification de médicament (DIN) ne doit contenir que des chiffres",
  medicationFormError_invalidUnit:
    "L'unité n'est plus valide. Veuillez sélectionner une unité dans la liste.",
  productionStage: {
    excel: {
      productCode: `Code du produit #{increment}`,
      productName: `Nom du produit #{increment}`,
    },
    precision: 'Précision obligatoire autre',
    title: 'Stades de production',
    titleFormAdd: 'Ajouter un stade de production',
    titleFormEdit: 'Modifier un stade de production',
    messageAddSuccess: 'Le stade de production a été ajouté avec succès.',
    messageEditSuccess: 'Le stade de production a été modifié avec succès.',
    messageDeleteSuccess: 'Le stade de production a été supprimé avec succès.',
    messageActivatedSuccess: 'Les stades de production ont été activés avec succès.',
    messageDeactivatedSuccess: 'Les stades de production ont été désactivés avec succès.',
    unitLimit: {
      kg: 'kg',
      days: 'Jours',
    },
  },
  productionStageGroup: {
    title: 'Regroupements',
    titleFormAdd: 'Ajouter un regroupement',
    titleFormEdit: 'Modifier un regroupement',
    messageAddSuccess: 'Le regroupement a été ajouté avec succès.',
    messageEditSuccess: 'Le regroupement a été modifié avec succès.',
    messageDeleteSuccess: 'Le regroupement a été supprimé avec succès.',
    messageActivatedSuccess: 'Les regroupements ont été activés avec succès.',
    messageDeactivatedSuccess: 'Les regroupements ont été désactivés avec succès.',
  },
  productionStage_canHaveSite_formLabel:
    "Peut avoir un site (si ce champ est laissé vide, c'est la valeur de l'espèce qui sera utilisée)",
  productionStage_canHaveSite_listerLabel: 'Peut avoir un site',
  productionStage_officialSite_formLabel:
    "N° de site règlementé (si ce champ est laissé vide, c'est la valeur de l'espèce qui sera utilisée)",
  productionStage_officialSite_listerLabel: 'N° de site règlementé',
  permitNumber_validation_badFormat:
    'Le numéro de permis doit être dans le format suivant : [1 à 10 chiffres]-[1 à 5 chiffres]-[1 à 3 chiffres]',
  permit_importFormCsv_formTitle: 'Importation de la liste BAK',
  permit_importFormCsv_importTypeLabel: "Type d'importation",
  permit_importFormCsv_importTypePublic: 'Liste publique',
  permit_importFormCsv_importFileLabel: 'Fichier CSV',
  permit_importFormCsv_btnLabel: 'Importer fichier CSV',
  permit_importFormCsv_sendingFile: 'Importation en cours.',
  permit_importFormCsv_fileTreated: 'Importation terminée.',
  permit_importFormCsv_serverError: "L'importation a échoué.",
  permit_importFormCsv_permitInserted:
    '{count} {count,plural,one{permis inséré}other{permis insérés}}.',
  permit_importFormCsv_permitUpdated:
    '{count} {count,plural,one{permis modifié}other{permis modifiés}}.',
  permit_importFormCsv_permitError: '{count} permis en erreur.',
  permit_importFormCsv_permitEmptyEntry:
    'Le fichier CSV contient des lignes vides, ce qui signifie que seules certaines données ont été importées.',
  permit_importFormCsv_importTypeBak: 'Liste BAK',
  permit_importFormCsv_importFileBakLabel: 'Fichier EXCEL',
  declaration_labelDeclarationType: 'Type de déclaration',
  declaration_labelDeclarationType_SALE_SUPPLY: 'Vente ou fourniture',
  declaration_labelDeclarationType_RETURN: 'Retour',
  declaration_createdWebForm_web: 'Formulaire Web',
  declaration_createdWebForm_api: 'API',
  pendingDeclaration: {
    titleLister: 'Déclarations en attente',
    labelDeclarationLastModified: 'Sauvegarde',
    labelDeclarationRecipientName: 'Client',
    labelPermit: 'Permis',
    messageAddSuccess: "L'état a été ajouté avec succès.",
    messageEditSuccess: "L'état a été modifié avec succès.",
    messageDeleteSuccess: "L'état a été supprimé avec succès.",
  },
  navLink: {
    userLabel: 'Utilisateurs',
    securityLabel: 'Sécurité',
    pagesLabel: 'Pages',
    listerLabel: 'Lister',
    addLabel: 'Ajouter',
    change_password: 'Changer le mot de passe',
    recovery_codes: 'Récupérer les codes',
    label_404: '404',
  },
  table: {
    reset_filter_button: 'Réinitialiser le filtre',
    header: {
      active: 'Actif',
      action: 'Actions',
    },
  },
  table_noResult: 'Aucun résultat trouvé',
  pagination: {
    rows_per_page: 'Lignes par page',
    page: 'Page',
    pageOf: 'de',
    total_items: 'Total des éléments',
  },
  declarationStepper: {
    id: 'Nᴼ',
    recipientStepLabel: 'Client',
    recipientStepDesc: 'Acheteur ou receveur',
    siteStepLabel: 'Site de production',
    siteStepDesc: 'Les sites de production animale',
    productStepLabel: 'Produit',
    productStepDesc: 'Type de produits',
    medicationStepLabel: 'Médicament',
    medicationStepDesc: 'Médicament',
    speciesStepLabel: 'Espèce',
    speciesStepDesc: 'Espèce',
    declarationStepLabel: 'Déclaration',
    declarationStepDesc: 'Déclaration',
    veterinaireStepLabel: 'Médecin vétérinaire',
    veterinaireStepDesc: 'Médecin vétérinaire',
    nextStepBtn: 'Suivant',
    btnEdit: 'Modifier',
    btnDelete: 'Supprimer',
    recentLabel: 'Récents',
    mostUsedLabel: 'Fréquents',
    declarationDateLabel: 'Date de vente ou fourniture',
    declarationPermitLabel: 'Permis de déclaration',
    quantity: 'Quantité',
    concentration: 'Concentration',
    lastUsedDate: 'Dernière utilisation',
    nbUsed: "Nombre d'utilisations",
    concentrationUnit: 'Unité',
    concentrationUnitPPM: 'ppm',
    concentrationUnitMg_Kg: 'mg/kg',
    concentrationUnitG_T: 'g/tonne',
    concentrationUnitKG_T: 'kg/tonne',
    animalQtySourceType: {
      PRESCRIPTION: 'Prescription',
      CLIENT_REGISTRY: 'Registre client',
      OTHER: 'Autre',
    },
    providerSection: 'Information supplémentaire sur la vente ou fourniture',
    providerNumber: 'Référence interne',
    providerNote: 'Note interne',
    stepRecipient: {
      title: 'Client',
      recipientSelected: 'Client sélectionné',
      recipients: 'Liste des clients',
      addRecipient: 'Ajouter un client non mémorisé',
      editRecipient: 'Modifier un client mémorisé',
      recipientNameLabel: 'Nom',
      emptyRecentMostUsedListLabel: 'Aucun client trouvé',
    },
    stepSite: {
      title: 'Site receveur du produit médicamenteux',
      sitesSelected: 'Sites sélectionnés',
      sites: 'Liste des sites de production animale',
      emptyRecentMostUsedListLabel: 'Aucun site trouvé',
      sitePermitNumberFormatError: 'Le format du numéro de permis est incorrect',
    },
    stepProduct: {
      title: 'Détails des produits médicamenteux',
      qtyKgLabel: 'Quantité (kg)',
      productLabel: 'Produit',
      addProduct: 'Ajouter un produit',
      productionStageLabel: 'Espèce',
      animalQtyLabel: "Nombre d'animaux",
      animalQtyLabelShort: `Nombre d'animaux`,
      animalQtySourceLabel: 'Source',
      sourceInfos: "Source pour le nombre d'animaux",
      addProductBtn: 'Ajouter un produit',
      editProduct: 'Modifier un produit',
      noProduct: 'Aucun produit ajouté',
      site: 'Site',
      productSelected: 'Produits sélectionnés',
      otherQtySourceInfoLabel: 'Précisez la source',
      animalInfos: 'Informations sur les animaux',
      animalQuantityMax: 'Vous ne pouvez pas entrer plus de 10000000 animaux',
      productQuantityMax: 'Vous ne pouvez pas entrer plus de 1000000 kg',
      productQuantityMin: 'Vous ne pouvez pas entrer moins de -1000000 kg',
      speciesPrecision: 'Précisez',
      animalMinLimitDays: 'Nombre de jours minimum',
      animalMaxLimitDays: 'Nombre de jours maximum',
      animalMinLimitKg: 'Minimum kg',
      animalMaxLimitKg: 'Maximum kg',
      animalMaxLimitKgGreatherThanMin: 'Le maximum doit être supérieur au minimum',
      maxQty: 'Vous ne pouvez pas entrer plus de 1000',
    },
    stepMedication: {
      title: 'Médicaments commerciaux',
      concentrationLabel: 'Concentration kg/tonne',
      qtyKgLabel: 'Quantité en kg',
      calculatedKgLabel: 'Quantité en kg',
      addActiveIngredient: 'Ajouter un ingrédient actif',
      addActiveIngredientBtnLabel: 'Ingrédient actif',
      editActiveIngredient: 'Modifier un ingrédient actif',
      medications: 'Médicaments commerciaux',
      medication: 'Médicament commercial',
      ingredients: 'Ingrédients',
      ingredient: 'Ingrédient actif',
      btnAddMedication: 'Médicament commercial',
      addMedication: 'Ajouter un médicament commercial',
      editMedication: 'Modifier un médicament commercial',
      maxQtyKg: 'Vous ne pouvez pas entrer plus de 1000000 kg',
      maxConcentration: 'Vous ne pouvez pas entrer plus de 1000000',
      minConcentration: 'Vous ne pouvez pas entrer moins de 0.001',
    },
    stepVeterinaire: {
      title: 'Médecins vétérinaires prescripteurs',
      vetName: 'Nom',
      vetLicenseNumber: "Numéro de permis d'exercice",
      prescriptionDate: "Date d'émission de la prescription",
      addVeterinaire: 'Ajouter un médecin vétérinaire non mémorisé',
      editVeterinaire: 'Modifier un médecin vétérinaire',
      veterinaires: 'Médecins vétérinaires',
    },
  },
  declarationStepper_cantDeclareWarning: `Vous n'avez aucun permis valide pour déclarer.`,
  declarationStepper_declarationType: 'Type de déclaration',
  declarationStepper_declarationType_SALE_SUPPLY: 'Vente ou fourniture',
  declarationStepper_declarationType_RETURN: 'Retour',
  declarationStepper_declarationDateLabel_SALE_SUPPLY: 'Date de vente ou fourniture',
  declarationStepper_declarationDateLabel_RETURN: 'Date de retour',
  declarationStepper_declarationDate_Edit: 'Modifier une date de transaction',
  declarationStepper_declarationDate_Add: 'Ajouter une date de transaction',
  declarationStepper_declarationType_Edit: 'Modifier type de déclaration',
  declarationStepper_declarationType_Add: 'Ajouter type de déclaration',
  declarationStepper_stepMedication_addMedicationHelpTooltip_text:
    "Pour remplacer le médicament commercial par un ingrédient actif, il faut d'abord vider la liste de médicaments commerciaux. Ensuite, il faut sélectionner « Ajouter un ingrédient actif » et fournir les informations requises.",
  declarationStepper_stepMedication_addActiveIngredientHelpTooltip_text:
    "Pour remplacer l'ingrédient actif par un médicament commercial, il faut d'abord vider la liste des ingrédients actifs. Ensuite, il faut sélectionner « Ajouter un médicament commercial » et fournir les informations requises.",
  userApiKey_titleLister: "Clés d'API",
  userApiKey_excelName: 'ClésAPI',
  userApiKey_labelApiKey: 'API Key',
  userApiKey_labelName: 'Nom',
  userApiKey_labelExpiresAt: "Date d'expiration (1 an maximum)",
  userApiKey_labelCreatedBy: 'Créé par',
  userApiKey_labelUser: 'Nom utilisateur',
  userApiKey_addEntityTitle: "Ajouter une clé d'API",
  userApiKey_editEntityTitle: "Modifier une clé d'API",
  userApiKey_messageEditSuccess: 'La clé a été modifiée avec succès.',
  userApiKey_messageAddSuccess: 'La clé a été ajoutée avec succès.',
  userApiKey_messageDeleteSuccess: 'La clé a été supprimé avec succès.',
  userApiKey_messageDeleteFailure: 'La clé ne peut pas être supprimée du système',
  userApiKey_newKeyPopupMessage:
    "Veuillez cliquer sur le bouton pour copier la clé dans votre presse-papier et la sauvegarder de façon sécuritaire (voûte, etc.).{br}{br}Cette clé devra être ajoutée à l'entête (header) HTTP <b>X-AUTH-TOKEN</b> de vos requêtes vers l'API d'AntibiotiQC par votre logiciel.{br}{br}",
  userApiKey_newKeyPopupMessageWaring:
    "Cette clé n'est visible qu'une seule fois. Si vous la perdez, vous devrez en créer une nouvelle.",
  userApiKey_btnClosePlainKey: 'Fermer',
  userApiKey_newKeyCopy: 'Copier la clé',
  userApiKey_newKeyCopied: 'Clé copiée',
  userApiKey_roleLabel: 'Type de clé',
  userApiKey_role_importateur_permis: 'Importateur de permis',
  userApiKey_role_detenteur_permis: 'Détenteur de permis',
  confirmAccount: {
    start: 'Activation en cours.',
    success: 'Le compte est activé!',
    failure: 'Utilisateur non trouvé/Jeton expiré',
  },
  quantity: {
    exceed:
      'La quantité totale de médicaments dépasse la quantité de produit. Elle doit être inférieure ou égale.',
    exceedOrEqual:
      'La quantité totale de médicaments est égale ou dépasse la quantité de produit. Elle doit être inférieure.',
  },
  dirtyPrompt_title: 'Quitter le formulaire',
  dirtyPrompt_message:
    'Voulez-vous vraiment quitter le formulaire? Vos données non sauvegardées seront perdues.',
  dirtyPrompt_btnConfirm: 'Quitter',
  dirtyPrompt_btnCancel: 'Rester',
  passwordRequirement_minChar: 'Inclure au moins 14 caractères',
  passwordRequirement_number: 'Inclure un nombre',
  passwordRequirement_lowercase: 'Inclure une lettre minuscule',
  passwordRequirement_uppercase: 'Inclure une lettre majuscule',
  passwordRequirement_specialChar: 'Inclure un caractère spécial',
  declaration_addDeclaration_disableNotice: 'Cliquez ici pour ne plus afficher ce message',
  declaration_addDeclaration_globalNotice_title: 'Information sur les déclarations à fournir',
  declaration_addDeclaration_globalNotice:
    "Vous devez déclarer uniquement les transactions (ventes ou fournitures) d'aliments ou de prémélanges médicamenteux effectuées à des utilisateurs finaux, <b>ce qui inclut les administrations faites à vos propres animaux</b>.{br}{br}<b>Les transactions intermédiaires ne sont pas à déclarer</b> (par exemple, la vente d'un fabricant à un distributeur dans le but  que ce dernier revende le produit à des utilisateurs finaux).",
  declaration_addDeclaration_globalNotice_note: `Tous les guides et les tutoriels visant à faciliter l'utilisation de la plateforme AntibiotiQC sont disponibles sur le site Web d'Attestra.`,
  declarations_addDeclaration_recipientStep_recipientListHelptooltip_text:
    "Le client est l'acheteur dans le cas d'une vente (transaction financière), ou le receveur dans le cas d'une fourniture (transaction non financière) de l'aliment ou du prémélange médicamenteux.",
  declarations_addDeclaration_recipientForm_nameHelpTooltip_text:
    "Indiquez le nom de la personne physique ou morale (entreprise ou organisme) qui effectue l'achat ou la réception des aliments ou des prémélanges médicamenteux.",
  declarations_addDeclaration_recipientForm_addressHelpTooltip_text:
    "Indiquez l'adresse principale du client. Veuillez noter que cette adresse peut, dans certains cas, différer de celle des sites de livraison des produits.",
  declarations_addDeclaration_sitesList_tooltipHelp_text:
    "Il s'agit des sites où se trouvent les animaux auxquels sont destinés les prémélanges ou les aliments médicamenteux vendus ou fournis. <b>Notez que vous pouvez sélectionner plusieurs sites.</b>",
  all_goToAntibiotiQC: 'Aller sur AntibiotiQC',
  declarations_addDeclaration_concentrationHelpTooltip_text:
    "Cette concentration correspond à l'incorporation de « {elementName} » dans le produit « {productName} »",
  declarations_addDeclaration_quantityHelpTooltip_text:
    "Attention à ne pas confondre cette valeur avec la quantité de « {productName} » inscrite à l'étape « Produit ».",
  all_drug: 'médicament',
  all_theActiveIngredient: "l'ingrédient actif",
  declarations_addDeclaration_productForm_sourceHelpTooltip_text: `
  <p>Le nombre d'animaux pourrait figurer dans l'une des sources d'informations suivantes : </p>
  <ul>
    <li>Registre client (nombre d'animaux entrés dans le lot dans le cas d'élevage « tout-plein tout-vide » dont vous suivez les performances zootechniques);</li>
    <li>Prescription vétérinaire;</li>
    <li>Autre (à préciser).</li>
  </ul>
  `,
  declarations_addDeclaration_productForm_sitePermitNumber_warning_text_line1:
    "Vous déclarez la vente ou la fourniture d'un prémélange médicamenteux à {clientName} au site suivant : ",
  declarations_addDeclaration_productForm_sitePermitNumber_warning_text_line2_3_4: `
    {br}{br}
    Dans le cadre d'une vente ou d'une fourniture de prémélange médicamenteux, le client doit obligatoirement avoir un permis relatif aux prémélanges médicamenteux et aliments médicamenteux spécifique au site concerné par la vente ou la fourniture.
    {br}{br}
    Vous n'avez pas encore saisi ce numéro de permis.
  `,
  declarations_addDeclaration_productForm_sitePermitNumber_label:
    'Nᴼ de permis relatif aux prémélanges médicamenteux et aliments médicamenteux du site',
  declarations_addDeclaration_productForm_sitePermitNumber_divider_label:
    'Numéro de permis du site manquant',
  sitePermitNumber: 'N° de permis',
  siteNumber: 'N° de site',
  vetLicenseNumber: 'N° de license vétérinaire',
  excelDownload_btnLabel: 'Exporter',
  excelDownloadDetail_btnLabel: 'Exporter',
  excelDownload_currentPage_btnLabel: 'La page actuelle de la liste',
  excelDownload_allPage_btnLabel: 'Toutes les pages de la liste (≈15 000 résultats maximum)',
  excelDownload_allData_btnLabel: 'Les données complètes (CSV)',
  excelDownload_notification_title: 'Exportation exécutée avec succès.',
  excelDownload_notification_message: `L'exportation est terminée.`,
  excelDownload_notification_inProgress: `L'exportation est en cours.`,
  errors_notFound_title: 'Vous avez trouvé une place secrète!',
  errors_notFound_description: "Malheureusement, la page que vous cherchez n'existe pas.",
  errors_notFound_link: "Retour à l'accueil",
  accountActivation_title: 'Activation de votre compte',
  accountActivation_instructions:
    'Veuillez saisir un mot de passe pour vous connecter sur AntibiotiQC',
  accountActivation_attempt: 'Activation en cours.',
  accountActivation_success: 'Votre compte a été activé avec succès.',
  accountActivation_failed: 'Activation échouée',
  menu_menuItem_declarationModels_label: 'Modèles',
  declarationAdmin_declarationTemplateTable_title: 'Modèles de déclaration',
  declarationAdmin_declarationTemplateTable_name_column: 'Nom',
  declarationAdmin_declarationTemplateTable_description_column: 'Description',
  declarationAdmin_declarationTemplateTable_permitNumber_column: 'Permis du déclarant',
  declarationAdmin_declarationTemplateTable_createdAt_column: 'Transmission',
  declarationAdmin_declarationTemplateTable_declarationDate_column: 'Transaction',
  declarationAdmin_declarationTemplateTable_recipientName_column: 'Client',
  declarationAdmin_declarationTemplateTable_productionSite_column: 'Site de production',
  declarationAdmin_declarationTemplateTable_product_column: 'Produit',
  declarationAdmin_declarationTemplateTable_siteName_column: 'Nom du site',
  declarationAdmin_declarationTemplateTable_providerNumber_column: 'Nᴼ de référence interne',
  declarationAdmin_declarationTemplateTable_actions_column: 'Actions',
  declaration_createDeclarationTemplateForm_textInput_name_label: 'Nom du modèle',
  declaration_createDeclarationTemplateForm_textInput_name_placeholder:
    'Entrer le nom du modèle de déclaration',
  declaration_createDeclarationTemplateForm_textInput_description_label: 'Description',
  declaration_createDeclarationTemplateForm_textInput_description_placeholder:
    'Entrer la description du modèle de déclaration',
  declaration_createDeclarationTemplateForm_saveButton_label: 'Sauvegarder',
  declaration_createDeclarationTemplateForm_cancelButton_label: 'Annuler',
  declaration_createDeclarationListView_createTemplateDeclarationModal_title:
    'Créer un modèle de déclaration',
  all_systemMessage: 'Message du système',
  declaration_createDeclarationListView_createTemplateDeclarationModal_successNotification:
    'Le modèle de déclaration a été créé avec succès.',
  // Révision linguistique 2023-09-05 FIN
  all_yes: 'Oui',
  all_no: 'Non',
  excel: {
    declaration: {
      id: 'Nᴼ',
      declarationDate: 'Transaction',
      declarationPermit_permitNumber: 'Permis du déclarant',
      declarationType: 'Type de déclaration',
      sitePermitNumber: 'Permis du client',
      recipientName: 'Client',
      siteNumber: 'N° de traçabilité du site',
      siteName: 'Nom du site',
      product_nameFr: 'Produit',
      productQty: 'Quantité (kg) du produit',
      productionStage_nameFr: 'Stade de production',
      productionStageOtherInfo: 'Précision sur le stade de production',
      animalQtySource: `Source du nombre d'animaux`,
      animalQtySourceOtherInfo: "Précision sur la source du nombre d'animaux",
      animalQty: `Nombre d'animaux`,
      animalAgeMinLimit: 'Âge minimal',
      animalAgeMaxLimit: 'Âge maximal',
      prescriptionDate: `Émission de la prescription`,
      vetLicenseNumber: `Permis du médecin vétérinaire`,
      vetName: 'Médecin vétérinaire',
      recipientCoordinate_address_addressFirst: 'Adresse du client',
      recipientCoordinate_address_addressSecond: 'Adresse 2 du client',
      recipientCoordinate_address_unitNumber: `Numéro d'unité du client`,
      recipientCoordinate_address_civicNumber: 'Numéro de rue du client',
      recipientCoordinate_address_streetName: 'Nom de rue du client',
      recipientCoordinate_address_ruralRoute: 'Route rurale du client',
      recipientCoordinate_address_poBox: 'Boîte postale du client',
      recipientCoordinate_address_stationInformation: 'Information sur la station du client',
      recipientCoordinate_city: 'Ville du client',
      recipientCoordinate_postalCode: 'Code postal du client',
      recipientCoordinate_countrySubdivision_nameFr: 'Province du client',
      siteCoordinate_address_addressFirst: 'Adresse du site de production',
      siteCoordinate_address_addressSecond: 'Adresse 2 du site de production',
      siteCoordinate_address_unitNumber: `Numéro d'unité du site de production`,
      siteCoordinate_address_civicNumber: 'Numéro de rue du site de production',
      siteCoordinate_address_streetName: 'Nom de rue du site de production',
      siteCoordinate_address_ruralRoute: 'Route rurale du site de production',
      siteCoordinate_address_poBox: 'Boîte postale du site de production',
      siteCoordinate_address_stationInformation: 'Information sur la station du site de production',
      siteCoordinate_city: 'Ville du site de production',
      siteCoordinate_postalCode: 'Code postal du site de production',
      siteCoordinate_countrySubdivision_nameFr: 'Province du site de production',
      providerNumber: 'Référence interne',
      providerNote: 'Note interne',
      createdWebForm: 'Mode de transmission',
      createdAt: 'Transmission',
      declarationIngredient_activeIngredient_nameFr: `Ingrédient actif #{increment}`,
      declarationIngredient_qty: `Quantité (kg) de l'ingrédient actif #{increment}`,
      declarationIngredient_concentration: `Concentration de l'ingrédient actif #{increment}`,
      declarationIngredient_concentrationUnit: `Unité de mesure de l'ingrédient actif #{increment}`,
      declarationMedication_medication_nameFr: `Médicament commercial #{increment}`,
      declarationMedication_qty: `Quantité (kg)  du médicament commercial #{increment}`,
      declarationMedication_concentration: `Concentration du médicament commercial #{increment}`,
      declarationMedication_concentrationUnit: `Unité de mesure du médicament commercial #{increment}`,
      declarationIngredient_activeIngredient_nameFr_mapaq: `ingredient_actif_name_fr_{increment}`,
      declarationIngredient_qty_mapaq: `declaration_ingredient_qty_{increment}`,
      declarationIngredient_concentration_mapaq: `declaration_ingredient_concentration_{increment}`,
      declarationIngredient_concentrationUnit_mapaq: `declaration_ingredient_concentration_unit_{increment}`,
      declarationMedication_medication_nameFr_mapaq: `medication_name_fr_{increment}`,
      declarationMedication_qty_mapaq: `declaration_medication_qty_{increment}`,
      declarationMedication_concentration_mapaq: `declaration_medication_concentration_{increment}`,
      declarationMedication_concentrationUnit_mapaq: `declaration_medication_concentration_unit_{increment}`,
    },
    user: {
      status: `Statut de l'inscription`,
      active: `Statut de l'utilisateur`,
    },
    vetDeclaration: {
      createdAt: 'Transmission',
      declarationDate: 'Transaction',
      declarationType: 'Type de déclaration',
      omvqEstablishment_id: 'Établissement de déclaration',
      vetLicenseNumber: `Permis du médecin vétérinaire`,
      vetName: 'Médecin vétérinaire',
      providerNumber: 'Nᴼ de référence interne',
      providerNote: 'Note interne',
    },
  },
  notificationMessage: {
    emptyMessage: 'Pas de nouvelles notifications',
    title_0: 'Nouvelle fonctionnalité : Modèle de déclarations groupées',
    title_1: "Nouvelle fonctionnalité : Duplication d'un groupe de déclarations",
    title_2: 'Nouvelle fonctionnalité : Modification de site',
    message_0:
      'Dans la liste des déclarations, sélectionner les déclarations souhaitées et cliquer sur le bouton “Sauvegarder comme modèle” dans la barre de menu des déclarations. Les modèles sont accessibles dans le sous-menu “Modèles”.',
    message_1:
      'Dans la liste des déclarations, sélectionner les déclarations souhaitées et cliquer sur le bouton “Dupliquer” dans la barre de menu des déclarations.',
    message_2:
      'Fonctionnalité dans le menu de gauche, filtrer les déclarations pour mettre à jour les informations de site du résultat.',
  },
  omvqVeterinarian_permitNumber: 'Numéro de permis',
  omvqVeterinarian_name: 'Nom',
  omvqVeterinarian_email: 'Courriel',
  omvqVeterinarian_omvqStatus: 'Statut OMVQ',
  omvqVeterinarian_omvqStartDate: 'Date de début',
  omvqVeterinarian_omvqEndDate: 'Date de fin',
  omvqVeterinarian_status: `Statut AntibiotiQC`,
  omvqEstablishment_name: 'Nom',
  omvqEstablishment_address: 'Adresse',
  omvqEstablishment_phone: 'Téléphone',
  omvqVeterinarian_linkType: 'Lien',
  omvqEstablishmentCode_tableLister: 'Établissements vétérinaires',
  omvqEstablishmentCode_subMenuTitle: 'Établissements',
  omvqEstablishmentCode_messageEditSuccess: "Le code d'accès a été modifié avec succès.",
  omvqEstablishmentCode_messageDeleteSuccess: "Le code d'accès a été supprimé avec succès.",
  omvqEstablishmentCode_messageDeleteConfirmation:
    "Êtes-vous certain de vouloir supprimer ce code d'accès?",
  omvqEstablishmentCode_messageAddSuccess: "Le code d'accès a été ajouté avec succès.",
  omvqEstablishmentCode_labelCode: "Code d'accès",
  omvqEstablishmentCode_labelCodeType: 'Type',
  omvqEstablishmentCode_labelUserAccount: 'Utilisateur',
  omvqEstablishmentCode_codeType_OWNER: 'Propriétaire',
  omvqEstablishmentCode_codeType_VET: 'Locataire',
  omvqEstablishmentCode_codeType_NOT_VET: 'Gestionnaire',
  omvqEstablishmentCode_codeType_API_KEY: "Clé d'API",
  omvqEstablishmentCode_chooseCodeType: 'Choisir le type de code',
  omvqEstablishmentCode_chooseApiKey: "Choisir la clé d'API",
  omvqEstablishmentCode_linkCode: "Lier code d'accès",
  omvqEstablishmentCodeManagerForm_code: "Code d'accès",
  omvqEstablishmentCodeManagerForm_linkCode_title: "Lier un code d'accès",
  omvqEstablishmentCodeManagerForm_linkCode_messageSuccess: "Le code d'accès est lié avec succès.",
  organization_address: 'Adresse',
  organization_phone: 'Téléphone',
  organization_email: 'Courriel',
  organization_domain: 'Domaine autorisé',
  organization_code: 'Code',
  organization_species: `Espèce`,
  organization_tableListerListDomain: 'Liste des domaines autorisés',
  organization_tableListerHeaderDomain: 'Domaine autorisé',
  organization_tableListerAddDomain: 'Ajouter un domaine',
  organization_tableListerRemoveDomain: 'Retirer un domaine',
  organization_titleFormAdd: 'Ajouter une association',
  organization_titleFormEdit: 'Modifier une association',
  organization_messageEditSuccess: `L'association a été modifié avec succès.`,
  organization_messageAddSuccess: `L'association a été ajouté avec succès.`,
  organization_messageDeleteSuccess: `L'association a été supprimé avec succès.`,
  organization_emailFormatError: 'format de courriel invalide',
  organization_phoneFormatError: 'format de téléphone invalide',
  organization_department: 'Département',
  organization_tableListerAddDepartment: 'Ajouter un département',
  organization_tableListerRemoveDepartment: 'Retirer un département',
  organization_tableListerListDepartment: 'Liste des départements',
  organization_tableListerHeaderDepartment: 'Département',
  organization_tableListerHeaderDepartmentCode: 'Code',
  organization_tableListerListSpecies: 'Liste des espèces',
  organization_tableListerAddSpecies: 'Ajouter une espèce',
  organization_tableListerRemoveSpecies: 'Retirer une espèce',
  signupProfile: {
    veterinarian: 'Vétérinaire',
    veterinarianProfile: `Pour l’inscription d’un <b>médecin vétérinaire</b>, le courriel de correspondance inscrit dans les préférences de communication du membre à l’OMVQ est requis. Pour les <b>autres membres du personnel</b>, le code d’accès fourni par l'établissement vétérinaire est requis.`,
    permitOwner: 'Détenteur de permis',
    permitOwnerProfile: `Pour l’inscription d’un <b>détenteur de permis</b> relatif aux prémélanges médicamenteux et aliments médicamenteux, le numéro de permis et le code d’accès reçus par la poste ou de la part d’un collègue sont requis.`,
    permitOwnerProfileDev: `Pour l’inscription d’un <b>détenteur de permis</b> relatif aux prémélanges médicamenteux et aliments médicamenteux, le numéro de permis et le code d’accès sont requis`,
    producer: 'Producteur',
    producerProfile:
      'Pour l’inscription d’un <b>producteur (propriétaire d’animaux)</b>, un courriel est requis. Une fois le compte AntibiotiQC créé, il sera possible de procéder à la demande d’inscription au système de monitorage. Afin de valider l’identité du producteur, certaines informations précises sont requises, lesquelles varient selon le secteur de production.',
    whichProfil: 'Choisissez votre profil utilisateur.',
  },
  statistic_permitsWithTransmittedDeclarationRateView_registeredPermitsTypeS: 'Nombre d’inscrits S',
  statistic_permitsWithTransmittedDeclarationRateView_registeredPermitsTypeV: 'Nombre d’inscrits V',
  statistic_permitsWithTransmittedDeclarationRateView_registeredPermits: 'Nombre d’inscrits',
  statistic_permitsWithTransmittedDeclarationRateView_permitsWithTransmittedDeclaration_percentage:
    'Total de permis déclarants',
  statistics_apiTransmittedDeclarationsRateView_title: 'Modes de transmission',
  statistics_apiTransmittedDeclarationsRateView_description:
    'Présentation des déclarations en fonction de la date de transmission, selon le mode de transmission',
  statistics_apiTransmittedDeclarationsRateView_label_x: 'Date de transmission',
  statistics_acceptedTransmittedDeclarationsIndicator_title: 'Déclarations acceptées',
  statistics_acceptedTransmittedDeclarationsIndicator_generalDescription:
    'Indicateur visant à identifier les DP ayant des potentiels problèmes techniques (faible taux de succès)',
  statistics_acceptedTransmittedDeclarationsIndicator_description:
    'Description des déclarations acceptées',
  statistics_permitsWithTransmittedDeclarationRateView_title: 'Déclarants',
  statistics_permitsWithTransmittedDeclarationRateView_description:
    'Présentation des détenteurs de permis inscrits et ayant transmis au moins une déclaration acceptée',
  statistics_subscribebPermitsRateView_title: 'Inscriptions',
  statistics_subscribebPermitsRateView_description: 'Descriptif des inscriptions',
  statistic_permitsWithTransmittedDeclarationRateView_permitsWithTransmittedDeclaration:
    'Nombre déclarant',
  statistic_permitsWithTransmittedDeclarationRateView_totalPermits: 'Permis inscrits',
  statistics_percentageTable_acceptedDeclarationRate: 'Nombre de permis',
  statistics_duplicatedDeclarationsRateView_title: 'Déclarations en double',
  statistics_duplicatedDeclarationsRateView_label_x: 'Numéro de permis',
  statistics_duplicatedDeclarationsRateView_description: 'Description des déclarations en double',
  statistics_duplicatedDeclarationsRateView_duplicatedDeclarationsCount: 'Nombre de doublons',
  statistics_duplicatedDeclarationsRateView_apiTransmitted: 'Par API',
  statistics_duplicatedDeclarationsRateView_nonApiTransmitted: 'Manuellement',
  statistics_duplicatedDeclarationsSummary_permit_number: 'Numéro de permis',
  statistics_duplicatedDeclarationsSummary_sum: 'Nombre de doublons',
  statistics_declarationTransactionTypeRateView_title: 'Transactions',
  statistics_declarationTransactionTypeRateView_description:
    'Présentation des déclarations en fonction de la date de transaction, selon le type de déclaration',
  statistics_declarationTransactionTypeRateView_label_x: 'Date de transaction',
  statistics_declarationTransactionTypeRateView_declarationTypeSaleSupply:
    'Nombre de déclarations de vente ou fourniture',
  statistics_declarationTransactionTypeRateView_declarationTypeReturn:
    'Nombre de déclarations de retour',
  statistics_declarationTransactionTypeRateView_declarationTypeSaleSupply_percentage:
    '% de déclarations de vente ou fournitur',
  statistics_declarationTransactionTypeRateView_declarationTypeReturn_percentage:
    '% de déclarations de retour',
  statistics_amountOfActiveIngredientUsedPerAntibioticCategoryVeterinarianView_label_x: `Année de l'achat`,
  statistics_amountOfActiveIngredientUsedPerAntibioticCategoryVeterinarianView_label_y: `Quantité totale d'antibiotiques (en kg)`,
  statistics_amountOfActiveIngredientUsedPerAntibioticCategoryVeterinarianView_tableHeader_purchaseYear: `Année de l'achat`,
  statistics_amountOfActiveIngredientUsedPerAntibioticCategoryVeterinarianView_tableLabel_quantityTotal: `Totale`,
  statistics_activeIngredientAntibioticCategoryRateView_label_x: `Date de transaction`,
  statistics_amountOfActiveIngredientUsedVersusOthersIndicatorView_tooltip_amount:
    'Quantité d’ingrédient (kg)',
  sw_notification_versionUpdate: `Une nouvelle version est disponible!`,
  sw_notification_reload: `Recharger`,
  producerRequestAccess_form_buttonAdd: 'Transmettre',
  producerRequestAccess_form_organizationTitle:
    "À qui voulez-vous envoyer l'inscription au monitorage?",
  producerRequestAccess_form_ownerFullName:
    '<b>Prénom et nom du responsable, {br}ou nom de l’entreprise propriétaire de porcs</b>',
  producerRequestAccess_form_ownerFullName_input_field:
    'Prénom et nom du responsable, ou nom de l’entreprise propriétaire de porcs',
  producerRequestAccess_form_ownerFullName_subtext: '   ',
  producerRequestAccess_form_operatorNumber: `<b>Numéro unique de l'entreprise</b>{br}Identifiant unique interne aux Éleveurs de porcs du Québec`,
  producerRequestAccess_form_operatorNumber_input_field: `Numéro unique de votre entreprise interne aux Éleveurs de porcs du Québec (1 à 4 chiffres)`,
  producerRequestAccess_form_operatorNumber_subtext: `1 à 4 chiffres`,
  producerRequestAccess_form_authorisationCode:
    '{br}<b>Code d’autorisation</b>{br}fourni par les Éleveurs de porcs du Québec',
  producerRequestAccess_form_authorisationCode_input_field:
    'Code d’autorisation fourni par les Éleveurs de porcs du Québec',
  producerRequestAccess_form_authorisationCode_subtext:
    'Code obtenu sur le site <accesporcIntroLink>accesporc</accesporcIntroLink>.',
  producerRequestAccess_form_organizationProducerNumber:
    '<b>Numéro d’intervenant PorcTRACÉ (CPC)</b>{br} Identifiant unique du Conseil canadien du porc',
  producerRequestAccess_form_organizationProducerNumber_input_field:
    'Numéro d’intervenant PorcTRACÉ (CPC) - identifiant unique du Conseil canadien du porc (7 chiffres)',
  producerRequestAccess_form_organizationProducerNumber_subtext: '7 chiffres',
  producerRequestAccess_form_organizationProducerNumberFormatError:
    'Format de numéro CPC invalide. Le format accepté est de 7 chiffres.',
  producerRequestAccess_form_text1: `Pour finaliser votre inscription à la plateforme AntibiotiQC, veuillez compléter et soumettre le formulaire suivant. Les informations ci-dessous sont collectées dans le but unique de valider votre identité auprès des Éleveurs de porcs du Québec.`,
  producerRequestAccess_form_text2: `Il est à noter que les informations renseignées dans ce formulaire seront rendues disponibles aux Éleveurs de porcs du Québec afin qu'ils puissent valider votre identité. Elles ne seront rendues accessibles à aucun autre tiers, ni même au MAPAQ qui n'aura accès qu'à des données codées, c'est-à-dire à des données qui ne permettent pas d'identifier un propriétaire d'animaux de production ni un site de production`,
  producerRequestAccess_form_consent: 'Consentement',
  producerRequestAccess_form_consent_text1: `Ce consentement est valable pour tous mes troupeaux situés au Québec et concerne uniquement les informations utilisées pour les fins qui y sont décrites.`,
  producerRequestAccess_form_consent_text2: `Je comprends qu'en contrepartie de ce consentement j'aurai accès à mon rapport individuel confidentiel via la plateforme AntibiotiQC résumant les données de monitorage se rapportant aux sites de production hébergeant les animaux dont je suis propriétaire.`,
  producerRequestAccess_form_identificationConsent_checkbox:
    'Je consens à ce que les renseignements saisis dans ce formulaire soient transmis aux Éleveurs de porcs du Québec à des fins de validation de mon identité.',
  producerRequestAccess_form_monitoringConsent_checkbox:
    'Je consens à participer à la portion volontaire du monitorage qui implique que :',
  producerRequestAccess_form_monitoringConsent_list1: `Je donne le mandat à l'association des Éleveurs de porcs du Québec de transmettre au monitorage les données qu'elle détient sur mes sites de production`,
  producerRequestAccess_form_monitoringConsent_list2: `Je permets aux établissements vétérinaires avec lesquels je fais affaire de transmettre à AntibiotiQC mes données d'achats d'antibiotiques et d'antiparasitaires`,
  producerRequestAccess_form_consent_text3: `En transmettant ce formulaire, je reconnais avoir lu et compris l'information qu'il contient et que les renseignements saisis sont exacts. Le cas échéant, je reconnais aussi avoir obtenu les explications nécessaires à sa compréhension.`,
  producerRequestAccess_form_readMore_button: 'Lire pour plus de détails',
  producerRequestAccess_form_readMore_text1: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis commodo nec justo ac luctus. Donec aliquet vel tortor a gravida. Quisque pharetra tellus a sem placerat, id iaculis libero ornare. Etiam vel ex sollicitudin, sodales lacus eget, accumsan magna. Proin vel hendrerit dolor. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Integer sit amet condimentum tellus.`,
  producerRequestAccess_form_readMore_text2: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis commodo nec justo ac luctus. Donec aliquet vel tortor a gravida. Quisque pharetra tellus a sem placerat, id iaculis libero ornare. Etiam vel ex sollicitudin, sodales lacus eget, accumsan magna. Proin vel hendrerit dolor. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Integer sit amet condimentum tellus.`,
  useTerm_startPeriod: 'Date de début',
  useTerm_endPeriod: 'Date de fin',
  useTerm_termType: 'Type',
  useTerm_termType_UTILISATEUR: 'Utilisateur',
  useTerm_descriptionFr: `Conditions d'utilisation FR`,
  useTerm_descriptionEn: `Conditions d'utilisation EN`,
  useTerm_messageActivatedSuccess: `Les conditions d'utilisation ont été activés avec succès.`,
  useTerm_messageDeactivatedSuccess: `Les conditions d'utilisation ont été désactivés avec succès.`,
  useTerm_messageEditSuccess: `Les conditions d'utilisations ont été modifiées avec succès.`,
  useTerm_messageDeleteSuccess: `Les conditions d'utilisations ont été supprimées avec succès.`,
  statistics_percentageTable_percentage: 'Pourcentage (%)',
  statistics_permitsWithTransmittedDeclarationRateView_yScale_label:
    '% de détenteurs de permis ayant transmis une déclaration',
  statistics_permitsWithTransmittedDeclarationRateView_xScale_label: `Date d'inscription`,
  statistics_subscribedPermitsRateFiltersForm_period_label: 'Période',
  statistics_subscribedPermitsRateFiltersForm_period_placeholder:
    'Choisissez une date de début et une date de fin',
  statistics_permitsWithTransmittedDeclarationRateView_percentage:
    '% de détenteurs de permis ayant transmis une déclaration',
  statistics_subscribedPermitsRateLine_label: `% de détenteurs de permis inscrits`,
  statistics_subscribedPermitsRateLine_label_x: `Date d'inscription`,
  statistics_noDataAvailableMessage_text: 'Pas de données disponibles',
  statistics_percentageTable_total: 'Total',
  statistic_subscribedPermitsRateLine_registeredPermits: 'Nombre d’inscrits',
  statistic_subscribedPermitsRateLine_registeredPermitsTypeS: 'Nombre d’inscrits S',
  statistic_subscribedPermitsRateLine_registeredPermitsTypeV: 'Nombre d’inscrits V',
  statistic_subscribedPermitsRateLine_registeredPermits_percentage: 'Total de permis inscrits',
  statistic_subscribedPermitsRateLine_registeredPermitsTypeS_percentage:
    'Vente ou fourniture d’un prémélange médicamenteux ou d’un aliment médicamenteux (S)',
  statistic_subscribedPermitsRateLine_registeredPermitsTypeV_percentage:
    'Vente, fourniture et préparation d’un prémélange médicamenteux ou d’un aliment médicamenteux (V)',
  statistic_subscribedPermitsRateLine_allPermitsS: 'Nombre total S',
  statistic_subscribedPermitsRateLine_allPermitsV: 'Nombre total V',
  statistic_subscribedPermitsRateLine_allPermits: 'Nombre total',
  statistic_subscribedPermitsRateLine_registeredPermitsTypeS_toolTip:
    'Nombre de permis inscrits (S)',
  statistic_subscribedPermitsRateLine_registeredPermitsTypeV_toolTip:
    'Nombre de permis inscrits (V)',
  statistic_subscribedPermitsRateLine_registeredPermits_toolTip: 'Nombre total de permis inscrits',
  statistic_subscribedPermitsRateLine_allPermitsS_toolTip: 'Nombre total de permis (S)',
  statistic_subscribedPermitsRateLine_allPermitsV_toolTip: 'Nombre total de permis (V)',
  statistic_subscribedPermitsRateLine_allPermits_toolTip: 'Nombre total de permis',
  statistic_subscribedPermitsRateLine_registeredPermits_percentage_toolTip:
    'Pourcentage (%) total de permis inscrits',
  statistic_subscribedPermitsRateLine_registeredPermitsTypeS_percentage_toolTip:
    'Pourcentage (%) de permis inscrits (S)',
  statistic_subscribedPermitsRateLine_registeredPermitsTypeV_percentage_toolTip:
    'Pourcentage (%) de permis inscrits (V)',
  statistic_subscribedPermitsRateLine_registeredPermitsTypeS_tableLabel:
    'Nombre de permis inscrits (S)',
  statistic_subscribedPermitsRateLine_registeredPermitsTypeV_tableLabel:
    'Nombre de permis inscrits (V)',
  statistic_subscribedPermitsRateLine_registeredPermits_tableLabel:
    'Nombre total de permis inscrits',
  statistic_subscribedPermitsRateLine_allPermitsS_tableLabel: 'Nombre total de permis (S)',
  statistic_subscribedPermitsRateLine_allPermitsV_tableLabel: 'Nombre total de permis (V)',
  statistic_subscribedPermitsRateLine_allPermits_tableLabel: 'Nombre total de permis',
  statistic_subscribedPermitsRateLine_registeredPermits_percentage_tableLabel:
    'Pourcentage (%) total de permis inscrits',
  statistic_subscribedPermitsRateLine_registeredPermitsTypeS_percentage_tableLabel:
    'Pourcentage (%) de permis inscrits (S)',
  statistic_subscribedPermitsRateLine_registeredPermitsTypeV_percentage_tableLabel:
    'Pourcentage (%) de permis inscrits (V) ',
  statistics_apiTransmittedDeclarationsRateView_percentage: '% du total',
  useTerm_titleFormAdd: `Ajouter un conditions d'utilisation`,
  useTerm_titleFormEdit: `Modifier un conditions d'utilisation`,
  useTerm_messageAddSuccess: `Les conditions d'utilisations ont été ajoutées avec succès.`,
  btn_edit_toolTip: 'Modifier',
  btn_delete_toolTip: 'Supprimer',
  btn_play_toolTip: 'Créer une nouvelle déclaration',
  btn_help: 'Aide',
  statistic_apiTransmittedDeclarationsRateView_nonApiTransmittedDeclarations:
    'Nombre de déclarations via formulaire Web',
  statistic_apiTransmittedDeclarationsRateView_apiTransmittedDeclarations:
    'Nombre de déclarations via API',
  statistic_apiTransmittedDeclarationsRateView_apiTransmittedDeclarations_percentage:
    '% de déclarations via API',
  statistic_apiTransmittedDeclarationsRateView_nonApiTransmittedDeclarations_percentage:
    '% de déclarations via formulaire Web',
  statistics_premixNoPermitDeclarationsIndicator_title: 'Déclarations de prémélanges médicamenteux',
  statistics_premixNoPermitDeclarationsIndicator_description:
    'Description des déclarations de prémélanges médicamenteux',
  statistic_premixNoPermitDeclarationsIndicator_premixNoPermitDeclarations:
    'Déclarations de prémélange médicamenteux sans permis du site de production',
  statistic_premixNoPermitDeclarationsIndicator_premixWithPermitDeclarations:
    'Déclarations de prémélange médicamenteux avec permis du site de production',
  statistics_onTimeSubmittedDeclarationsRateView_title:
    'Nombre de déclarations acceptées transmises à temps',
  statistics_onTimeSubmittedDeclarationsRateView_description:
    'Description de nombre de déclarations acceptées transmises à temps',
  statistic_onTimeSubmittedDeclarationsRateView_onTimeSubmittedDeclarations:
    'Déclaration acceptées à temps',
  statistic_onTimeSubmittedDeclarationsRateView_notOnTimeSubmittedDeclarations:
    'Déclaration acceptées en retard',
  statistics_declarationTransmissionRateView_title: 'Déclarations transmises à temps',
  statistics_declarationTransmissionRateView_description: `Présentation de l'année de registre des déclarations en fonction de la date de transmission`,
  statistics_declarationTransmissionRateView_label_x: 'Date de transmission',
  statistics_declarationTransmissionRateView_tooltip_allDeclarations: 'Nombre total en {year}',
  statistics_declarationTransmissionRateView_tooltip_percentage: '% de {year}',
  all_total: 'Total',
  statistics_acceptedTransmittedDeclarationsIndicator_apiTransmitted: 'Par API',
  statistics_acceptedTransmittedDeclarationsIndicator_nonApiTransmitted: 'Manuellement',
  statistic_declarationsWithPremixInvalidRateView_declarationsWithPremixInvalid:
    'Déclarations de prémélange médicamenteux avec permis invalide',
  statistic_declarationsWithPremixInvalidRateView_declarationsWithPremixValid:
    'Déclarations de prémélange médicamenteux avec permis valide',
  statistics_declarationsWithPremixInvalidRateView_title:
    'Nombre de déclarations de prémélanges médicamenteux avec permis invalide',
  statistics_declarationsWithProductionSiteRateView_title:
    'Numéros de traçabilité des sites de production',
  statistics_declarationsWithProductionSiteRateView_description:
    'Description de numéros de traçabilité des sites de production,',
  all_percentage: 'Pourcentage (%)',
  statistics_declarationsWithProductionSiteRateView_canHaveSite_yes: 'Oui',
  statistics_declarationsWithProductionSiteRateView_canHaveSite_no: 'Non',
  all_siteNumber: 'N° de site',
  all_permitNumber: 'N° de permis',
  signup_i_have_a_access_code: "J'ai un code de gestionnaire d'établissement vétérinaire",
  signup_omvq_establishment_code_activation_code_label:
    "Code de gestionnaire d'établissement vétérinaire",
  signup_omvq_establishment_code_activation_code_placeholder:
    "Votre code de gestionnaire d'établissement vétérinaire",
  signup_i_don_t_have_a_access_code:
    "Je n'ai pas de code de gestionnaire d'établissement vétérinaire",
  userAccountVet_validation_notValidCode: 'Ce code est invalide',
  statistic_acceptedTransmittedDeclarationsIndicator_acceptedDeclarationRate: 'Nombre de permis',
  statistic_acceptedTransmittedDeclarationsIndicator_label_x: 'Taux de succès.',
  statistic_yScaleLabel_percentage: 'Pourcentage (%)',
  statistic_yScaleLabel_number: 'Nombre de déclarations',
  systemBase_showNotification_accessDenied: 'Vous ne pouvez pas exécuter cette action',
  declaration_declarationTemplate_deleteSuccessMessage:
    'Le modèle de déclaration a été supprimé avec succès.',
  all_notification_batchDelete:
    '{count} {count,plural,one{élément a été supprimé avec succès}other{éléments ont été supprimés avec succès}}',
  all_notification_batchDelete_inProgress: 'Suppression en cours...',
  all_notification_batchDeleteFailure:
    'Impossible de supprimer {count} {count,plural,one{élément car il est utilisé}other{éléments car ils sont utilisés}}',
  footer_politique: 'Politique de confidentialité',
  footer_condition: "Conditions d'utilisation",
  foreign_key_messageDeleteFailure: "Impossible de supprimer l'élément, car il est utilisé",
  activeMedicationDins_dinNumber: `{dinNumber}`,
  serviceUnavailable: 'Le système est inaccessible pour le moment, veuillez réessayer plus tard',
  serviceGenericError:
    'Erreur du système, si vous faites une extraction Excel, il est possible que votre requête soit trop volumineuse, veuillez raffiner votre recherche, sinon, veuillez contacter le support technique.',
  userProfile_authorization_required: `Veuillez choisir entre Oui ou Non pour continuer`,
  statistic_premixNoPermitDeclarationsIndicator_declarationsPremixWithValidPermitCount_percentage: `% permis valide`,
  statistic_premixNoPermitDeclarationsIndicator_declarationsPremixWithInvalidPermitCount_percentage: `% numéro de permis erroné`,
  statistic_premixNoPermitDeclarationsIndicator_declarationsPremixWithExpiredPermitCount_percentage: `% permis expiré`,
  statistic_premixNoPermitDeclarationsIndicator_declarationsPremixWithMissingPermitCount_percentage: `% numéro de permis manquant`,
  statistic_premixNoPermitDeclarationsIndicator_declarationsPremixWithDeclarationPermitSameAsSitePermitCount_percentage: `% de permis identique au déclarant`,
  statistic_premixNoPermitDeclarationsIndicator_declarationsPremixWithValidPermitCount: `Nb permis valide`,
  statistic_premixNoPermitDeclarationsIndicator_declarationsPremixWithInvalidPermitCount: `Nb numéro de permis erroné`,
  statistic_premixNoPermitDeclarationsIndicator_declarationsPremixWithExpiredPermitCount: `Nb permis expiré`,
  statistic_premixNoPermitDeclarationsIndicator_declarationsPremixWithMissingPermitCount: `Nb numéro de permis manquant`,
  statistic_premixNoPermitDeclarationsIndicator_declarationsPremixWithDeclarationPermitSameAsSitePermitCount:
    'Nb de permis identique au déclarant',
  statistic_premixNoPermitDeclarationsIndicator_declarationsPremixCount: 'Total',
  statistic_premixNoPermitDeclarationsIndicator_declarationPercentage: '% de déclarations',
  invalidPermitsDetailsRateView_permit_number: 'Numéro de permis',
  invalidPermitsDetailsRateView_permit_type: 'Catégorie de permis',
  invalidPermitsDetailsRateView_operator_name: 'Nom abrégé de l’exploitant',
  invalidPermitsDetailsRateView_entity_social_reason: 'Raison sociale',
  invalidPermitsDetailsRateView_nbr_success: 'Nombre de succès.',
  invalidPermitsDetailsRateView_nbr_error: "Nombre d'erreur",
  invalidPermitsDetailsRateView_pourcentage_success: '% de succès.',
  invalidPermitsDetailsRateView_transmission_mode: 'Mode de transmission',
  transmission_mode_nonApi: 'Manuellement',
  transmission_mode_api: 'Par API',
  vetDeclaration_titleLister: `Déclarations`,
  vetDeclaration_labelDeclarationDate: 'Transaction',
  vetDeclaration_labelDeclarationCreatedAt: 'Transmission',
  vetDeclaration_labelDeclarationType: 'Type de déclaration',
  vetDeclaration_labelDeclarationType_SALE_SUPPLY: 'Vente ou fourniture',
  vetDeclaration_labelDeclarationType_RETURN: 'Retour',
  vetDeclaration_omvqEstablishment: 'Établissement de déclaration',
  vetDeclaration_prescriber: 'Prescripteur',
  declaration_productionSiteFormFilter_siteNumber: 'Numéro de site',
  declaration_productionSiteFormFilter_siteName: 'Nom du site',
  declaration_productionSiteFormFilter_address: 'Adresse',
  declaration_productionSiteFormFilter_city: 'Ville',
  declaration_productionSiteFormFilter_postalCode: 'Code postal',
  declaration_productionSiteFormFilter_country: 'Pays',
  declaration_productionSiteFormFilter_countrySubdivision: 'Province/État',
  declaration_help_body: `<p><b>Modèle de déclarations groupées</b></p><p>Vous pouvez créer un modèle de déclaration comprenant plusieurs déclarations.<ol><li>Sélectionner les déclarations souhaitées <b>d'un même client et d'un même permis du déclarant</b> en cochant la case située à l'extrémité gauche de chaque déclaration.</li><li>Cliquer sur le bouton “Sauvegarder comme modèle” dans la barre de menu des déclarations.</li><li>Pour utiliser le modèle créé, aller dans le sous-menu “Modèles”, dans la section à gauche de l’écran.</li></ol></p><p><b>Duplication d'un groupe de déclarations</b></p><p>Vous pouvez dupliquer plusieurs déclarations ensemble.<ol><li>Sélectionner les déclarations souhaitées <b>d'un même client et d'un même permis du déclarant</b> en cochant la case située à l'extrémité gauche de chaque déclaration.</li><li>Cliquer sur le bouton “Dupliquer” dans la barre de menu des déclarations.</li></ol></p>`,
  declarations_saveModel_serverError:
    'Vous ne pouvez pas créer de modèle, les déclarations choisies sont invalides',
  declarations_error_undefined: 'Indéfini',
  productionStage_vetValidation_listerLabel: 'Validation vétérinaire',
  productionStage_vetValidation_formLabel: 'Validation vétérinaire',
  species_speciesForm_labelVetValidation: 'Validation vétérinaire',
  species_vetValidation_listerLabel: 'Validation vétérinaire',
  statistics_duplicatedDeclarationsRateView_generalDescription:
    'Détection de déclarations potentiellement répétées',
  declaration_declarationTable_duplicateSubtitle: 'Filtre de doublons',
  statistics_subscribedPermitsRateLine_permitsTypeS_percentage: 'Pourcentage (%) de permis S',
  statistics_subscribedPermitsRateLine_permitsTypeV_percentage: 'Pourcentage (%) de permis V',
  statistics_subscribedPermitsRateLine_total_percentage: 'Pourcentage (%) total de permis',
  statistic_permitsWithTransmittedDeclarationRateView_permitsSWithTransmittedDeclarationCount_percentage:
    'Vente ou fourniture d’un prémélange médicamenteux ou d’un aliment médicamenteux (S)',
  statistic_permitsWithTransmittedDeclarationRateView_permitsVWithTransmittedDeclarationCount_percentage:
    'Vente, fourniture et préparation d’un prémélange médicamenteux ou d’un aliment médicamenteux (V)',
  statistic_permitsWithTransmittedDeclarationRateView_registeredPermits_percentage:
    'Pourcentage (%) de permis déclarant',
  statistic_permitsWithTransmittedDeclarationRateView_permitsSWithTransmittedDeclarationCount:
    'Nombre déclarant S',
  statistic_permitsWithTransmittedDeclarationRateView_permitsVWithTransmittedDeclarationCount:
    'Nombre déclarant V',
  statistic_permitsWithTransmittedDeclarationRateView_permitsWithTransmittedDeclarationCount:
    'Nombre déclarant',
  statistic_permitsWithTransmittedDeclarationRateView_permitsSWithTransmittedDeclarationCount_percentage_toolTip:
    'Pourcentage (%) de permis déclarants (S)',
  statistic_permitsWithTransmittedDeclarationRateView_permitsVWithTransmittedDeclarationCount_percentage_toolTip:
    'Pourcentage (%) de permis déclarants (V)',
  statistic_permitsWithTransmittedDeclarationRateView_permitsWithTransmittedDeclaration_percentage_toolTip:
    'Pourcentage (%) total de permis déclarants',
  statistic_permitsWithTransmittedDeclarationRateView_permitsSWithTransmittedDeclarationCount_toolTip:
    'Nombre de permis déclarants (S)',
  statistic_permitsWithTransmittedDeclarationRateView_permitsVWithTransmittedDeclarationCount_toolTip:
    'Nombre de permis déclarants (V)',
  statistic_permitsWithTransmittedDeclarationRateView_permitsWithTransmittedDeclaration_toolTip:
    'Nombre total de permis déclarants',
  statistic_permitsWithTransmittedDeclarationRateView_registeredPermitsTypeS_toolTip:
    'Nombre total de permis inscrits (S)',
  statistic_permitsWithTransmittedDeclarationRateView_registeredPermitsTypeV_toolTip:
    'Nombre total de permis inscrits (V)',
  statistic_permitsWithTransmittedDeclarationRateView_registeredPermits_toolTip:
    'Nombre total de permis inscrits',
  statistic_permitsWithTransmittedDeclarationRateView_permitsSWithTransmittedDeclarationCount_percentage_tableLabel:
    'Pourcentage (%) de permis déclarants (S)',
  statistic_permitsWithTransmittedDeclarationRateView_permitsSWithTransmittedDeclarationCount_tableLabel:
    'Nombre de permis déclarants (S)',
  statistic_permitsWithTransmittedDeclarationRateView_registeredPermitsTypeS_tableLabel:
    'Nombre total de permis inscrits (S)',
  statistic_permitsWithTransmittedDeclarationRateView_permitsVWithTransmittedDeclarationCount_percentage_tableLabel:
    'Pourcentage (%) de permis déclarants (V)',
  statistic_permitsWithTransmittedDeclarationRateView_permitsVWithTransmittedDeclarationCount_tableLabel:
    'Nombre de permis déclarants (V)',
  statistic_permitsWithTransmittedDeclarationRateView_registeredPermitsTypeV_tableLabel:
    'Nombre total de permis inscrits (V)',
  statistic_permitsWithTransmittedDeclarationRateView_permitsWithTransmittedDeclaration_percentage_tableLabel:
    'Pourcentage (%) total de permis déclarants',
  statistic_permitsWithTransmittedDeclarationRateView_permitsWithTransmittedDeclaration_tableLabel:
    'Nombre total de permis déclarants',
  statistic_permitsWithTransmittedDeclarationRateView_registeredPermits_tableLabel:
    'Nombre total de permis inscrits',
  statistics_productionStageGroupSingleSelect_label: `Regroupement de stade de production`,
  statistics_productionStageGroupSingleSelect_placeholder: `Choisir le regroupement de stade de production`,
  statistics_organizationNumberOfConsentsWithdrawalIndicator_title:
    'Nombre de retraits de consentement',
  user_userForm_organization: 'Association',
  user_userForm_organizationDepartment: 'Département',
  docs_api_permitHolder_regulationTitle:
    'Données à transmettre au MAPAQ suivant la modification du Règlement sur les prémélanges médicamenteux et les aliments médicamenteux destinés aux animaux.',
  docs_api_permitHolder_regulationText1:
    'Les modifications apportées aux articles 14 et 15 du Règlement sur les prémélanges médicamenteux et les aliments médicamenteux destinés aux animaux, découlant de la Loi sur la protection sanitaire des animaux, exigent maintenant la transmission annuelle du registre des ventes et fournitures des prémélanges et des aliments médicamenteux des détenteurs de certaines catégories de permis relatifs aux prémélanges médicamenteux et aliments médicamenteux. Pour plus de détails sur ce règlement et ses nouvelles exigences, ',
  docs_api_permitHolder_regulationLink1: 'cliquez ici.',
  docs_api_permitHolder_regulationText2:
    'Aussi, un document identifiant les données à transmettre au ministère de l’Agriculture, des Pêcheries et de l’Alimentation (MAPAQ) est disponible, ',
  docs_api_permitHolder_regulationText3:
    "L'interface API (en anglais, *application programming interface*) est le principal moyen d’envoyer le registre des ventes et fournitures des prémélanges et des aliments médicamenteux au MAPAQ.",
  docs_api_permitHolder_supportTitle: 'Soutien aux utilisateurs',
  docs_api_permitHolder_supportText:
    'Si vous avez des questions à propos de la présente documentation technique, vous pouvez contacter le ',
  docs_api_permitHolder_supportLink: `Service à la clientèle d'Attestra`,
  docs_api_permitHolder_siteValidationTitle:
    'Validation des numéros de site pour les Bovins, Ovins et Cervidés.',
  docs_api_permitHolder_siteValidationTextPreProdHTML:
    "La plateforme AntibiotiQC est configurée pour valider le numéro de traçabilité du site pour les bovins, les ovins et les cervidés qui sont visés par le Règlement sur l'identification et la traçabilité de certains animaux, découlant de la Loi sur la protection sanitaire des animaux. Dans l'environnement de test préproduction, pour ces espèces seuls les numéros suivants sont acceptés : <ul><li>QC0000000</li><li>QC1111111</li><li>QC2222222</li><li>QC3333333</li><li>QC4444444</li><li>QC5555555</li><li>QC6666666</li><li>QC7777777</li><li>QC8888888</li><li>QC9999999</li></ul>",
  docs_api_permitHolder_siteValidationTextHTML:
    "La plateforme AntibiotiQC est configurée pour valider le numéro de traçabilité du site pour les bovins, les ovins et les cervidés qui sont visés par le Règlement sur l'identification et la traçabilité de certains animaux, découlant de la Loi sur la protection sanitaire des animaux.",
  docs_api_permitHolder_limitationTitle: 'Limitation de débit',
  docs_api_permitHolder_limitationTextHTML:
    "Pour des raisons de gestion de l'infrastructure, Attestra met une limite de débit sur l'API, donc si vous recevez un code <b>429 (Too Many Requests)</b>, il suffit de réessayer et éventuellement de diminuer votre débit vers l'API d'Attestra.",
  docs_api_permitHolder_errorTitle: 'Gestion des erreurs',
  docs_api_permitHolder_errorTextHTML:
    "Il est possible pour différentes raisons que l'API retourne des erreurs. Il est recommandé au client d'en faire une gestion appropriée.<ul><li>4xx : Erreur du client : erreur de validation, erreur de format, etc.</li><li>5xx : Erreur du serveur : maintenance, problème du serveur, etc.</li></ul>",
  docs_api_permitHolder_exampleTitle: "Exemples d'utilisation",
  docs_api_permitHolder_exampleText1HTML:
    "Voici quelques exemples d'utilisation pour vous aider. Notez cependant que vous êtes libre d'utiliser l'API à votre convenance. Nous utiliserons <b>ABC123</b> comme clé d'API et un format cURL pour les exemples.",
  docs_api_permitHolder_exampleText2:
    'Les formats possibles sont présentés ci-dessous, toutefois, nous recommandons les deux premiers : ',
  docs_api_permitHolder_exampleListHTML:
    "<ul><li>jsonld: [ 'application/ld+json' ]</li><li>json: [ 'application/json' ]</li><li>xml: [ 'application/xml', 'text/xml' ]</li><li>yaml: [ 'application/x-yaml' ]</li><li>csv: [ 'text/csv' ]</li><li>html: [ 'text/html' ]</li></ul>",
  docs_api_permitHolder_exampleOneTitle:
    'Connecter une liste déroulante à la liste des médicaments',
  docs_api_permitHolder_exampleOneText1:
    'Faire un appel à la ressource des médicaments sans pagination (pagination=false) pour recevoir la liste complète. Ici nous ferons un tri par nom ascendant (order[nameFr]=ASC).',
  docs_api_permitHolder_exampleOneText2:
    'Analyser la réponse et bâtir votre liste déroulante avec les informations souhaitées.',
  docs_api_permitHolder_exampleOneText3:
    "Vous êtes libre de conserver le @id, le id ou le code de chaque médicament. Vous pouvez ignorer les objets medicationActiveIngredients; cela représente la concentration des ingrédients actifs du médicament. Si vous gardez le id et @id, vous devez les configurer par environnement : il n'est pas garanti qu'ils soient identiques entre les environnements. Les codes seront quant à eux identiques.",
  docs_api_permitHolder_exampleTwoTitle: 'Transmettre une déclaration de vente ou de fourniture',
  docs_api_permitHolder_exampleTwoResponse: "Réponse de l'API",
  docs_api_permitHolder_exampleTwoText1:
    'Trouver les @id pour la transmission. Ceci devra être fait pour toutes les ressources ayant une référence dans les déclarations (permis de déclaration, province, stade de production, produit, médicament commercial et ingrédient actif)\n' +
    '\n' +
    'Voici un exemple avec le code.',
  docs_api_permitHolder_exampleTwoText2:
    'Voici un exemple avec le id, vous pouvez faire un appel pour vous assurer de la validité ou bien ajouter le préfix du IRI à votre id (ex. id = 3, IRI = /api/medications/3)',
  docs_api_permitHolder_exampleTwoText3: 'Envoi de la déclaration',
  docs_api_permitHolder_exampleTwoText4:
    'Conservez le @id pour faire des modifications sur cette nouvelle déclaration.',
  docs_api_permitHolder_exampleTwoDotOneTitle:
    'Transmettre une modification sur une déclaration de vente ou de fourniture',
  docs_api_permitHolder_exampleTwoDotOneResponse: "Réponse de l'API",
  docs_api_permitHolder_exampleTwoDotOneText1: `Envoi de la déclaration — @id = /api/declarations/13.`,
  docs_api_permitHolder_exampleTwoDotOneText3:
    'Veuillez renvoyer la déclaration complète. Tous les champs doivent être inclus, même ceux dont les valeurs n’ont pas été modifiées.',
  docs_api_permitHolder_exampleThreeTitle: "Rotation des clés d'API",
  docs_api_permitHolder_exampleThreeText1:
    "Création d'une nouvelle clé d'API. Ne pas oublier de conserver le @id du userAccount généré ainsi que la plainKey, qui elle ne sera plus accessible.",
  docs_api_permitHolder_exampleThreeResponse: "Réponse de l'API",
  docs_api_permitHolder_exampleThreeText2:
    "Associer la clé d'API à votre permis. Si vous n'avez pas le @id du permis, vous pouvez aller sur /api/permits pour le trouver.",
  docs_api_permitHolder_exampleThreeText3:
    "Retirer l'association de la clé actuelle à votre permis (optionnel)",
  docs_api_vet_title: 'À venir...',
  docs_api_vet_regulationTitle:
    'Données à transmettre par les établissements vétérinaires dans le cadre de la portion volontaire du système de monitorage de l’utilisation des antibiotiques chez les animaux au Québec',
  docs_api_vet_regulationText1:
    'La portion volontaire du système de monitorage est présentement en cours de développement. Son déploiement s’effectue progressivement, un secteur de production à la fois, en commençant par le secteur porcin. Les établissements vétérinaires qui vendent des antibiotiques et des antiparasitaires sont appelés à y contribuer.',
  docs_api_vet_regulationLink1: 'cliquez ici.',
  docs_api_vet_regulationText2:
    'Aussi, un document identifiant les données à transmettre au ministère de l’Agriculture, des Pêcheries et de l’Alimentation (MAPAQ) est disponible, ',
  docs_api_vet_regulationText3:
    "Veuillez noter que dans le cadre de cette portion volontaire, l'interface API (en anglais, Application Programming Interface) constitue l'unique moyen pour les établissements vétérinaires d’envoyer les données.",
  docs_api_vet_supportTitle: 'Soutien aux utilisateurs',
  docs_api_vet_supportText:
    'Si vous avez des questions à propos de la présente documentation technique, vous pouvez contacter le ',
  docs_api_vet_supportLink: `Service à la clientèle d'Attestra`,
  docs_api_vet_siteValidationTitle:
    'Validation des numéros de site pour les Bovins, Ovins et Cervidés.',
  docs_api_vet_siteValidationTextPreProdHTML:
    "La plateforme AntibiotiQC est configurée pour valider le numéro de traçabilité du site pour les bovins, les ovins et les cervidés qui sont visés par le Règlement sur l'identification et la traçabilité de certains animaux, découlant de la Loi sur la protection sanitaire des animaux. Dans l'environnement de test préproduction, pour ces espèces seuls les numéros suivants sont acceptés : <ul><li>QC0000000</li><li>QC1111111</li><li>QC2222222</li><li>QC3333333</li><li>QC4444444</li><li>QC5555555</li><li>QC6666666</li><li>QC7777777</li><li>QC8888888</li><li>QC9999999</li></ul>",
  docs_api_vet_siteValidationTextHTML:
    "La plateforme AntibiotiQC est configurée pour valider le numéro de traçabilité du site pour les bovins, les ovins et les cervidés qui sont visés par le Règlement sur l'identification et la traçabilité de certains animaux, découlant de la Loi sur la protection sanitaire des animaux.",
  docs_api_vet_limitationTitle: 'Limitation de débit',
  docs_api_vet_limitationTextHTML:
    "Pour des raisons de gestion de l'infrastructure, Attestra met une limite de débit sur l'API, donc si vous recevez un code <b>429 (Too Many Requests)</b>, il suffit de réessayer et éventuellement de diminuer votre débit vers l'API d'Attestra.",
  docs_api_vet_errorTitle: 'Gestion des erreurs',
  docs_api_vet_errorTextHTML:
    "Il est possible pour différentes raisons que l'API retourne des erreurs. Il est recommandé au client d'en faire une gestion appropriée.<ul><li>401 : clé d'API absente, invalide ou expirée.</li><li>404 : ressource introuvable, ou déclaration qui ne vous appartient pas.</li><li>422 : erreur de validation, voir l'exemple « Gérer les erreurs de validation ».</li><li>Autres 4xx : erreur du client (format, droits d'accès, etc.).</li><li>5xx : erreur du serveur (maintenance, problème du serveur, etc.).</li></ul>",
  docs_api_vet_exampleTitle: "Exemples d'utilisation",
  docs_api_vet_exampleText1HTML:
    "Voici quelques exemples d'utilisation pour vous aider. Notez cependant que vous êtes libre d'utiliser l'API à votre convenance. Nous utiliserons <b>ABC123</b> comme clé d'API et un format cURL pour les exemples.",
  docs_api_vet_exampleText2:
    'Les formats possibles sont présentés ci-dessous, toutefois, nous recommandons les deux premiers : ',
  docs_api_vet_exampleListHTML:
    "<ul><li>jsonld: [ 'application/ld+json' ]</li><li>json: [ 'application/json' ]</li><li>xml: [ 'application/xml', 'text/xml' ]</li><li>yaml: [ 'application/x-yaml' ]</li><li>csv: [ 'text/csv' ]</li><li>html: [ 'text/html' ]</li></ul>",
  docs_api_vet_exampleServerHTML:
    "Remplacez <b>[serveur]</b> par <b>api-antibiotiqc.attestra.com</b> en production ou par <b>api-monitorage-demo.attestra.com</b> dans l'environnement de test. La documentation OpenAPI complète est disponible en <apiLink>production</apiLink> et en <apiDevLink>test</apiDevLink>. Les @id (IRI) varient d'un environnement à l'autre : recherchez-les par leur code plutôt que de les coder en dur.",
  docs_api_vet_response: "Réponse de l'API",
  docs_api_vet_rulesTitle: 'Règles de validation des déclarations',
  docs_api_vet_rulesTextHTML:
    "Les règles ci-dessous s'appliquent à la ressource <b>/api/vet_declarations</b> pour l'espèce porcine, la seule actuellement prise en charge. Une déclaration qui ne les respecte pas est refusée avec un code <b>422</b> (voir l'exemple « Gérer les erreurs de validation »).",
  docs_api_vet_rulesField: 'Champ',
  docs_api_vet_rulesRule: 'Règle',
  docs_api_vet_rule_omvqEstablishment:
    "Requis. @id d'un établissement actif auquel votre clé d'API est associée.",
  docs_api_vet_rule_declarationDate:
    'Requis. Format AAAA-MM-JJ. Ne peut pas être dans le futur, ni antérieure à la date du consentement du producteur.',
  docs_api_vet_rule_declarationType:
    'Requis. <b>SALE_SUPPLY</b> (vente ou fourniture) ou <b>RETURN</b> (retour ou correction).',
  docs_api_vet_rule_animalCategory:
    "Requis. @id d'une catégorie animale de l'espèce porcine (POR).",
  docs_api_vet_rule_siteRecipientNumber:
    "Requis. Le numéro de site (100 caractères maximum) doit exister. Le couple numéro de site et numéro de producteur (recipientNumber) doit correspondre à une demande d'accès acceptée par le producteur dans AntibiotiQC.",
  docs_api_vet_rule_siteCoordinate:
    'Requis. Ville, code postal, province et adresse. La province doit être le Québec (CA-QC).',
  docs_api_vet_rule_recipient:
    'Requis. Nom et coordonnées du destinataire. Le code postal doit être valide pour la province.',
  docs_api_vet_rule_vet:
    "Numéro de permis d'exercice à 4 chiffres. Le numéro et le nom deviennent requis lorsque la déclaration contient un ingrédient actif sous ordonnance au Québec (ordonnanceQc) et que le site est au Québec.",
  docs_api_vet_rule_medications:
    "Sans préparation magistrale : exactement un médicament. L'unité (unit) doit être égale au unitRequired du médicament (G, ML ou UNIT). Quantité strictement supérieure à 0,001 et d'au plus 100 000 ; pour un RETURN, quantité négative entre -100 000 et -0,001 (exclu).",
  docs_api_vet_rule_ingredients:
    "Uniquement pour une préparation magistrale. Unité <b>MG</b> obligatoire. Quantité strictement supérieure à 0,1 et d'au plus 100 000 ; pour un RETURN, quantité négative entre -100 000 et -0,1 (exclu). Un même ingrédient ne peut apparaître qu'une fois.",
  docs_api_vet_rule_magistral:
    'Si magistralPreparation est vrai, preparationQuantity (entre 0 exclu et 100 000) et preparationUnit (G, ML ou UNIT) doivent être fournis ensemble. Sinon, ils doivent être vides.',
  docs_api_vet_rule_provider:
    "Optionnels. Réservés à l'usage interne de votre logiciel (numéro de facture, note). Non validés par AntibiotiQC.",
  docs_api_vet_rule_forbidden:
    'Doivent être vides pour le porc : animalNumber, visitReason, activeFilesQty, animalWeight, animalBirthDate, prescriptionDate, prescriptionNumber, prescriptionRenewalDate et prescriptionRenewalNumber.',
  docs_api_vet_referenceTitle: 'Obtenir les références (@id) à utiliser dans une déclaration',
  docs_api_vet_referenceTextHTML:
    "Une déclaration référence d'autres ressources par leur @id (IRI) : établissement, catégorie animale, province, médicament ou ingrédient actif. Les codes sont identiques dans tous les environnements, mais les @id ne le sont pas : recherchez-les par code et conservez-les par environnement. Seuls les médicaments antibiotiques et antiparasitaires, ainsi que les ingrédients actifs antibiotiques, sont visibles pour un vétérinaire.",
  docs_api_vet_referenceMedication:
    "Rechercher un médicament commercial par son code. Conservez son @id et son unitRequired : l'unité de la déclaration doit y correspondre.",
  docs_api_vet_referenceIngredient:
    "Rechercher un ingrédient actif par son code (préparations magistrales). L'unité est toujours MG.",
  docs_api_vet_referenceSpecies: "Trouver l'espèce porcine, puis ses catégories animales.",
  docs_api_vet_referenceEstablishment: 'Lister les établissements auxquels votre clé est associée.',
  docs_api_vet_referenceSubdivision: 'Trouver le @id de la province de Québec.',
  docs_api_vet_saleTitle: 'Transmettre une déclaration de vente ou de fourniture',
  docs_api_vet_saleTextHTML:
    'Déclaration de type <b>SALE_SUPPLY</b> pour un médicament commercial. Le site et le producteur doivent avoir donné leur consentement dans AntibiotiQC. Utilisez <b>providerNumber</b> pour y inscrire votre propre référence (ex. numéro de facture).',
  docs_api_vet_saleRequest: 'Envoi de la déclaration',
  docs_api_vet_saleResponse:
    "Réponse de l'API (201 Created). Conservez le @id pour modifier ou supprimer cette déclaration.",
  docs_api_vet_updateTitle: 'Modifier une déclaration',
  docs_api_vet_updateTextHTML:
    "Renvoyez la déclaration complète sur son @id, y compris les champs non modifiés. Les lignes de médicaments et d'ingrédients actifs sont remplacées par celles envoyées (elles reçoivent de nouveaux @id). Les coordonnées du site et du destinataire sont mises à jour sur place.",
  docs_api_vet_updateRequest: 'Envoi de la modification — @id = /api/vet_declarations/16',
  docs_api_vet_updateResponse: "Réponse de l'API (200 OK, extrait)",
  docs_api_vet_returnTitle: 'Déclarer un retour ou une correction',
  docs_api_vet_returnTextHTML:
    'Un retour se déclare comme une nouvelle déclaration de type <b>RETURN</b>, avec une <b>quantité négative</b>. La réponse (201 Created) a la même structure que pour une vente.',
  docs_api_vet_returnRequest: 'Envoi du retour',
  docs_api_vet_magistralTitle: 'Déclarer une préparation magistrale',
  docs_api_vet_magistralTextHTML:
    "Avec <b>magistralPreparation</b> à vrai, déclarez les ingrédients actifs (en MG) plutôt qu'un médicament commercial, ainsi que la quantité totale préparée (<b>preparationQuantity</b> et <b>preparationUnit</b>). La réponse (201 Created) a la même structure que pour une vente.",
  docs_api_vet_magistralRequest: 'Envoi de la préparation magistrale',
  docs_api_vet_deleteTitle: 'Supprimer une déclaration',
  docs_api_vet_deleteTextHTML:
    "L'API répond <b>204 No Content</b> sans contenu. Un appel subséquent sur le même @id retourne <b>404</b>.",
  docs_api_vet_deleteRequest: 'Suppression — @id = /api/vet_declarations/16',
  docs_api_vet_errorsTitle: 'Gérer les erreurs de validation',
  docs_api_vet_errorsTextHTML:
    "Une déclaration invalide est refusée avec le code <b>422</b>. Toutes les erreurs sont retournées en une seule réponse dans <b>violations</b> : <b>propertyPath</b> indique le champ en cause, <b>message</b> est destiné à l'utilisateur (en français) et <b>code</b> est stable, à utiliser dans votre logiciel pour traiter l'erreur.",
  docs_api_vet_errorsRequest:
    'Envoi d’une déclaration dont le site est en Ontario et dont la quantité est nulle',
  docs_api_vet_errorsResponse: "Réponse de l'API (422 Unprocessable Entity)",
  docs_api_vet_errorsUnauthorized: "Réponse de l'API lorsque la clé est invalide ou expirée (401)",
  docs_api_vet_apiKeyTitle: "Rotation des clés d'API",
  docs_api_vet_apiKeyCreate:
    "Créer une nouvelle clé d'API. Conservez le @id du userAccount généré ainsi que la plainKey : elle ne sera plus jamais affichée.",
  docs_api_vet_apiKeyLink:
    "Associer la nouvelle clé à votre établissement. Le @id de l'établissement est disponible sur /api/omvq_establishments.",
  docs_api_vet_apiKeyUnlink:
    "Retirer l'association de l'ancienne clé (optionnel) : trouvez le @id de son association, puis supprimez-la. Cette opération doit être faite par le vétérinaire propriétaire de l'établissement.",
  dataAccessApiKey_createDataAccessApiKeyForm_textInput_name_label: 'Name',
  dataAccessApiKey_createDataAccessApiKeyForm_textInput_name_placeholder:
    'Entrez le nom de la clée',
  dataAccessApiKey_createDataAccessApiKeyForm_expiredAt_label: "Date d'expiration (1 an maximum)",
  dataAccessApiKey_createDataAccessApiKeyForm_expiredAt_placeholder:
    "Choissisez la date d'expiration",
  dataAccessApiKey_createDataAccessApiKeyForm_modal_title: "Créer une clé d'API",
  dataAccessApiKey_createDataAccessApiKeyForm_cancelButton_label: 'Annuler',
  dataAccessApiKey_createDataAccessApiKeyForm_saveButton_label: 'Sauvegarder',
  dataAccessApiKey_createDataAccessApiKeyForm_role_label: 'Rôle',
  dataAccessApiKey_createDataAccessApiKeyForm_role_placeholder: 'Choissisez un rôle',
  dataAccessApiKey_labelName: 'Nom',
  dataAccessApiKey_labelExpiresAt: "Date d'expiration",
  dataAccessApiKey_titleLister: "Clé d'API - Administration",
  dataAccessApiKey_role_label: 'Rôle',
  dataAccessApiKey_active: "Clé d'API activée",
  dataAccessApiKey_inactive: "Clé d'API désactivée",
  dataAccessApiKey_messageDeleteSuccess: "Clé d'API supprimée avec succès.",
  dataAccessApiKey_messageDeleteFailure: "Erreur lors de la suppression de la clé d'API",
  all_consents: 'Consentements',
  errors_fatal_title: 'Oupsss...',
  errors_fatal_description: "Malheureusement une erreur inattendue s'est produite.",
  errors_fatal_link: "Retour à l'accueil",
  statistics_permitSuccessRateIndicator_title: "Suivi du taux de succès d'un permis",
  statistics_permitSuccessRateIndicator_generalDescription:
    'Indicateur visant à suivre le taux de succès pour un permis de DP',
  producerRequestAccess_associationUserForm_accessCode_label: "Code d'accès",
  producerRequestAccess_associationUserForm_accessCode_placeholder: "Entrez le code d'accès",
  producerRequestAccess_associationUserForm_title:
    'Veuillez entrer les informations qui vous ont été envoyées',
  producerRequestAccess_veterinarianAndEstablishmentSearchForm_title:
    'Rechercher un médecin vétérinaire ',
  producerRequestAccess_associationUserForm_veterinarians_placeholder:
    'Rechercher un médecin vétérinaire ',
  producerRequestAccess_veterinarianAndEstablishmentSearchForm_table_name: 'Nom',
  producerRequestAccess_veterinarianAndEstablishmentSearchForm_table_clinic:
    'Établissements vétérinaires',
  producerRequestAccess_veterinarianAndEstablishmentSearchForm_table_permitNumber:
    'Numéro de permis d’exercice',
  producerRequestAccess_veterinarianAndEstablishmentSearchForm_table_confirm: 'Confirmer',
  producerRequestAccess_editSiteForm_omvqVeterinarians_label: 'Médecin vétérinaire',
  producerRequestAccess_editSiteForm_title: 'Recherche d’un médecin vétérinaire',
  producerRequestAccess_multiSiteUpdate_button: 'Ajouter des partages',
  searchMulitSelect_searchResults: 'Résultats de la recherche',
  searchMulitSelect_selectedOptions: 'Médecins vétérinaires sélectionnés',
  statistic_permitSuccessRateIndicator_permitSuccessRate: 'Taux de succès (%)',
  statistic_permitSuccessRateIndicator_nbErrors: "Nombre d'erreurs",
  statistic_permitSuccessRateIndicator_nbSuccess: 'Nombre de succès.',
  statistic_permitSuccessRateIndicator_nbTotal: 'Total de déclaration',
  statistics_permitSuccessRateIndicator_filterForm_permitSelect_label: 'Permis',
  statistics_permitSuccessRateIndicator_filterForm_permitSelect_placeholder: 'Choissez un permis',
  statistics_permitSuccessRateIndicator_yScaleLabel: `Taux de succès (%)`,
  statistics_permitSuccessRateIndicator_xScaleLabel: `Date de transmission`,
  report_download_title: `Données codifiées`,
  report_download_btnLabel: 'Extraire',
  report_download_filterDownloadForm_startPeriod: `Date de début`,
  report_download_filterDownloadForm_endPeriod: `Date de fin`,
  report_download_filterDownloadForm_count: `Résultats / Maximum : {count} / {threshold}`,
  report_download_filter_notification_inProgress: `Filtrage est en cours.`,
  report_download_filter_notification_title: `Filtrage exécuté avec succès.`,
  report_download_filter_notification_message: `Filtrage est terminée.`,
  report_download_fileTitle: `DonnéesCodifiées`,
  producerRequestAccessStepper_stepOneLabel: `Information sur l’inscription`,
  producerRequestAccessStepper_stepOneDesc: `Système de monitorage de l’utilisation des antibiotiques`,
  producerRequestAccessStepper_stepOne_title: `Information sur l’inscription au système de monitorage de l’utilisation des antibiotiques`,
  producerRequestAccessStepper_stepOne_subTitle: `Propriétaires de porcs du Québec`,
  producerRequestAccessStepOne_section1:
    `Le système de monitorage multiespèce de l’utilisation des antibiotiques (ci-après « Monitorage ») vise à collecter les données de ventes d’antibiotiques et d’antiparasitaires effectuées dans le domaine vétérinaire au Québec, d’analyser ces données et de retourner les résultats aux producteurs et médecins vétérinaires dans le but de les outiller dans une initiative d’amélioration continue de leurs pratiques. Les connaissances générées par le Monitorage permettront également d’orienter les programmes d’aide et d’accompagnement, ainsi que d’ajuster les initiatives collectives sectorielles dans le but ultime de préserver l’efficacité des antibiotiques et d’assurer une agriculture durable.{br}{br}` +
    `Le Monitorage est un programme gouvernemental sous la responsabilité du ministère de l’Agriculture, des Pêcheries et de l’Alimentation (MAPAQ). Ce dernier a mandaté Attestra pour développer une base de données centrale conçue pour recevoir, héberger et gérer sécuritairement et confidentiellement les données issues du Monitorage, ainsi que de donner aux acteurs impliqués la possibilité de consulter leurs données. La solution informatique développée pour répondre à ces besoins est la plateforme AntibiotiQC.{br}{br}` +
    `L’inscription au Monitorage donne l’opportunité aux propriétaires d’animaux d’élevage hébergés sur des sites localisés au Québec de contribuer aux efforts collectifs de lutte contre la résistance aux antibiotiques et d’accéder via leur compte AntibiotiQC à leurs données d’achats d’antibiotiques et d’antiparasitaires arrimées avec leurs données d’élevage.{br}{br}`,
  producerRequestAccessStepOne_accordion_header1: `Afin de vous inscrire au Monitorage, vous devez remplir et soumettre un formulaire qui a trois buts précis.`,
  producerRequestAccessStepOne_accordion_list1:
    'Recueillir des renseignements nécessaires à la confirmation, par Les Éleveurs de porcs du Québec, de votre statut de propriétaire de porcs.{br}{br}' +
    'Cette validation a pour but d’assurer que les données de Monitorage qui seront associées à votre compte AntibiotiQC soient rendues accessibles à la bonne personne, c’est-à-dire au propriétaire des animaux. Ces renseignements seront conservés confidentiellement et divulgués à aucun tiers sans un consentement explicite de votre part. Dans le cadre du Monitorage, le MAPAQ n’aura accès qu’à des données dont les renseignements personnels sont codés, c’est-à-dire à des données qui ne permettent pas d’identifier un propriétaire ou une entreprise propriétaire d’animaux de production ni un site de production.{br}{br}',
  producerRequestAccessStepOne_accordion_list2:
    'Recueillir votre consentement pour que les renseignements saisis dans le formulaire d’inscription soient partagés aux Éleveurs de porcs du Québec dans l’unique but de valider votre identité et de confirmer que vous êtes un propriétaire de porcs.{br}{br}',
  producerRequestAccessStepOne_accordion_list3:
    'Recueillir votre consentement pour participer à la portion volontaire du Monitorage. Ce consentement est donné aux établissements vétérinaires avec lesquels vous faites affaire pour transmettre vos données d’achats d’antibiotiques et d’antiparasitaires, ainsi qu’aux Éleveurs de porcs du Québec pour transmettre les informations sur vos sites de production (ci-après vos « Données ») à la plateforme AntibiotiQC. Il permet également au MAPAQ, dans le cadre du Monitorage d’accéder à vos Données uniquement sous forme codifiée.',
  producerRequestAccessStepOne_accordion_list3_list1:
    '<u>Implications de votre participation</u>{br}' +
    'Une participation à la portion volontaire du Monitorage implique que vos Données ',
  producerRequestAccessStepOne_accordion_list3_list1_line2:
    ' soient récoltées afin d’être centralisées et arrimées à vos données d’achats d’antibiotiques et d’antiparasitaires ',
  producerRequestAccessStepOne_accordion_list3_list1_line3:
    ' effectués auprès de meuneries. Ainsi, vous aurez accès à vos Données centralisées sous leur forme détaillée et elles pourront être interprétées au moyen d’un rapport d’étalonnage confidentiel.{br}{br}' +
    'Votre participation ne requiert aucun temps significatif de votre part. Une fois le formulaire complété, vos Données seront recueillies auprès des établissements vétérinaires et des Éleveurs de porcs du Québec sans nécessiter votre assistance.{br}{br}' +
    'Votre participation est volontaire et n’est associée à aucun risque significatif pour vous ou votre exploitation. Un refus de participer à la portion volontaire du monitorage n’entraîne aucun inconvénient pour vous ou vos élevages.{br}{br}',
  producerRequestAccessStepOne_accordion_list3_list2:
    '<u>Gestion et conservation des données</u>{br}' +
    'Dans le cadre du Monitorage, le MAPAQ aura accès à vos Données uniquement sous leur forme codée, c’est-à-dire que les renseignements permettant d’identifier un propriétaire participant, un site de production, un établissement vétérinaire, ou un médecin vétérinaire prescripteur seront retirés et remplacés par un code. Seul une équipe restreinte au sein d’Attestra, gestionnaire de la plateforme AntibiotiQC, aura un accès contrôlé à vos Données brutes.{br}{br}' +
    'Vos Données brutes récoltées dans le cadre du Monitorage seront conservées confidentiellement et ne pourront être communiquées qu’avec le consentement explicite des participants concernés ou selon les dispositions prévues à la <legisQuebecA2Link><i>Loi sur l’accès aux documents des organismes publics et sur la protection des renseignements personnels</i></legisQuebecA2Link> <i>(chapitre A-2.1)</i>. Vos Données seront conservées sur des serveurs localisés au Canada, et des mesures de sécurité des données sont en place afin de prévenir ou d’atténuer les risques d’incidents de confidentialité. Pour toute demande de rectification ou question en lien avec la protection de vos renseignements, vous pouvez vous adresser au MAPAQ à <mapaqInfoMailTo>accesinformation@mapaq.gouv.qc.ca</mapaqInfoMailTo>.{br}{br}' +
    'Le système de monitorage est une initiative qui prévoit être pérenne. Ainsi, les données de Monitorage collectées seraient utilisées tant que le système de monitorage est actif, car nécessaires à son fonctionnement. Cependant, en cas de démantèlement du système de monitorage, seules les données d’intérêt public anonymisées (quantités de médicaments vendus et inventaires par site de production et type de production) seront archivées afin de conserver des tendances historiques.{br}{br}',
  producerRequestAccessStepOne_accordion_list3_list3:
    '<u>Retrait du consentement</u>{br}' +
    'Une fois le processus d’inscription finalisé, un participant peut retirer son consentement à tout moment sans pénalité en se rendant dans la section « Monitorage - consentement, partage et accès » de son compte AntibiotiQC. Il est également possible pour un participant de demander la suppression de ses informations, entraînant une destruction de ses renseignements personnels récoltés dans le cadre de la portion volontaire du Monitorage, en s’adressant au MAPAQ à l’adresse <mapaqInfoMailTo>accesinformation@mapaq.gouv.qc.ca</mapaqInfoMailTo>. Pour être recevable, une telle demande doit s’appuyer sur une justification suffisante comme un préjudice lié à l’utilisation des renseignements ou le fait que celle-ci contrevienne à la loi ou à une ordonnance judiciaire. Contrairement à un simple retrait, il est important de noter que la suppression entraîne la perte des données de Monitorage volontaires précédemment collectées. Par conséquent, si un producteur décide de participer à nouveau au Monitorage, l’historique de ses données volontaires ne sera plus disponible.',
  producerRequestAccessStepOne_accordion_tooltip1: `<b>Données d’achats d’antibiotiques et d’antiparasitaires</b>{br}<ul><li>Nom et adresse de l’établissement vétérinaire vendeur;</li>
<li>Date de la facture et type de transaction (vente ou retour/crédit);</li>
<li>Nom et quantité des antibiotiques et antiparasitaires vendus;</li>
<li>Nom et adresse de l’acheteur ou numéro d’identification de l’acheteur;</li>
<li>Adresse et numéro PorcTRACÉ du site de production hébergeant les animaux{br} auxquels le produit est destiné;</li>
<li>Espèce, catégorie animale et nombre d’animaux auxquels le produit est destiné;</li>
<li>Nom du médecin vétérinaire prescripteur et son numéro de permis d’exercice.</li></ul>`,
  producerRequestAccessStepOne_accordion_tooltip2: `<b>Informations sur vos sites de production</b>{br}<ul><li>Nom, adresse et identifiant unique du propriétaire des animaux ou de l’entreprise {br}et de la division propriétaire des animaux;</li>
<li>Nom, adresse, identifiant unique et date d’assignation du site de production {br}(numéro de site PorcTRACÉ et AQC) et des bâtiments;</li>
<li>Espèce animale, stade de production, nombre d’animaux présents sur le site {br}(capacité maximale ou production annuelle du site).</li></ul>`,
  producerRequestAccessStepOne_section2: `Pour toute question concernant le Monitorage ou le processus d’inscription au Monitorage, communiquez avec les Éleveurs de porcs du Québec à l’adresse suivante <epqAntibioMailTo>antibiotiques@leseleveursdeporcs.quebec</epqAntibioMailTo> ou contactez l’équipe responsable du Monitorage au MAPAQ à <mapaqAntibioMailTo>AntibiotiQC@mapaq.gouv.qc.ca</mapaqAntibioMailTo>. Pour toute question technique associée à la plateforme AntibiotiQC, communiquez avec le Service à la clientèle d'Attestra via <requestManagementLink>ce lien</requestManagementLink>.{br}{br}`,
  producerRequestAccessStepOne_section3: `En passant à l’étape suivante, vous reconnaissez avoir lu et compris l’information ci-dessus et avoir obtenu les explications nécessaires à sa compréhension, le cas échéant.{br}{br}`,
  producerRequestAccessStepper_stepTwoLabel: `Inscription`,
  producerRequestAccessStepper_stepTwoDesc: `Formulaire d’inscription`,
  producerRequestAccessStepper_stepTwo_title: `Formulaire d’inscription au système de monitorage de l’utilisation des antibiotiques`,
  producerRequestAccessStepper_stepTwo_subTitle: `Propriétaires de porcs du Québec`,
  producerRequestAccessStepTwo_section1: `Afin de vous inscrire au Monitorage, veuillez remplir et soumettre le formulaire suivant.`,
  producerRequestAccessStepTwo_section2: `Renseignements qui seront partagés aux Éleveurs de porcs du Québec dans l’unique but de valider votre identité`,
  producerRequestAccessStepper_stepThreeLabel: `Consentements`,
  producerRequestAccessStepper_stepThreeDesc: `Options de partage des données`,
  producerRequestAccessStepper_stepThree_title: `Consentements pour vous inscrire au Monitorage`,
  producerRequestAccessStepper_stepThree_subTitle: `Propriétaires de porcs du Québec`,
  producerRequestAccessStepThree_section1: `La participation est volontaire, un refus de consentir n’aura aucun impact sur vous ou vos élevages. L’inscription au Monitorage nécessite l’acceptation des deux consentements ci-dessous. Un participant peut retirer son consentement à tout moment sans pénalité directement dans son compte AntibiotiQC.{br}{br}`,
  producerRequestAccessStepThree_section2: `Ces consentements concernent uniquement les informations utilisées pour les fins qui y sont décrites.{br}{br}`,
  producerRequestAccessStepThree_identificationConsent_checkbox: `En cochant cette case, je consens à ce que les renseignements saisis dans ce formulaire soient transmis aux Éleveurs de porcs du Québec, à l’unique fin qu’ils puissent confirmer que je suis bel et bien propriétaire de porcs hébergés sur des sites localisés au Québec.`,
  producerRequestAccessStepThree_monitoringConsent_checkbox: `En cochant cette case, je consens à ce que tous les porcs hébergés sur des sites localisés au Québec et dont je suis propriétaire participent à la portion volontaire du monitorage jusqu’à ce que je n’en sois plus propriétaire, jusqu’à ce que je retire mon consentement ou jusqu’à un maximum de sept (7) ans.`,
  producerRequestAccessStepThree_section3: `En donnant mon consentement, j’autorise :
  <ul>
   <li>
      <p>Les établissements vétérinaires avec lesquels je fais affaire à transmettre à la plateforme AntibiotiQC les informations qu’ils détiennent concernant mes achats d’antibiotiques et d’antiparasitaires destinés à mes élevages :</p>
      <ul>
         <li>Nom et adresse de l’établissement vétérinaire vendeur;</li>
         <li>Date de la facture et type de transaction (vente ou retour/crédit);</li>
         <li>Nom et quantité des antibiotiques et antiparasitaires vendus;</li>
         <li>Nom et adresse de l’acheteur ou numéro d’identification de l’acheteur;</li>
         <li>Adresse et numéro PorcTRACÉ du site de production hébergeant les animaux auxquels le produit est destiné;</li>
         <li>Espèce, catégorie animale et nombre d’animaux auxquels le produit est destiné;</li>
         <li>Nom du médecin vétérinaire prescripteur et son numéro de permis d’exercice.</li>
      </ul>
   </li>
   <li>Les Éleveurs de porcs du Québec à transmettre à la plateforme AntibiotiQC les informations qu’ils détiennent sur mes sites de production :
      <ul>
         <li>Nom, adresse et identifiants uniques du propriétaire des animaux (numéro d’intervenant PorcTRACÉ (CPC) et numéros de producteur) de l’entreprise et de la division propriétaire des animaux;</li>
         <li>Nom, adresse, identifiants uniques et date d’assignation du site de production (numéro de site PorcTRACÉ et AQC) et des bâtiments;</li>
         <li>Espèce animale, stade de production, nombre d’animaux présents sur le site (capacité maximale ou production annuelle du site).</li>
      </ul>
   </li>
   <li>Le MAPAQ à accéder, dans la cadre du Monitorage, aux données collectées auprès des établissements vétérinaires et des Éleveurs de porcs du Québec uniquement sous leur forme codée par site de production, c’est-à-dire que les renseignements permettant d’identifier un producteur, un site de production, un médecin vétérinaire prescripteur et un établissement vétérinaire vendeur seront masqués;</li>
</ul>{br}`,
  producerRequestAccessStepThree_section4: `Mon consentement et autorisation sont donnés aux fins suivantes :
<ul>
   <li>À partir des données codées granulaires :
      <ul>
         <li>La production de rapports de monitorage individuels confidentiels pour les producteurs et les médecins vétérinaires;</li>
      </ul>
   </li>
   <li>À partir des données anonymisées agrégées :
      <ul>
         <li>La production de rapports sectoriels confidentiels et d’un rapport public;</li>
         <li>Le développement et la diffusion d’outils de sensibilisation et d’éducation;</li>
         <li>L’identification d’axes d’amélioration de l’usage des antimicrobiens;</li>
         <li>L’évaluation des retombées des programmes mis en place;</li>
         <li>La mise en commun avec des données agrégées de résistance aux antibiotiques.</li>
      </ul>
   </li>
</ul>{br}`,
  producerRequestAccessStepThree_section5: `Je comprends qu’en contrepartie de ces consentements, j’aurai accès à mon rapport individuel confidentiel via mon compte AntibiotiQC. Ce rapport résumera les données de monitorage se rapportant aux sites de production hébergeant les animaux dont je suis propriétaire.{br}{br}`,
  producerRequestAccessStepThree_section6: `En soumettant ce formulaire, je reconnais que les renseignements saisis sont exacts et je reconnais également avoir lu et compris l’information qu’il contient. Le cas échéant, je reconnais avoir obtenu les explications nécessaires à sa compréhension.`,
  producerRequestAccessStepper_stepComplete_title: `Confirmation`,
  producerRequestAccessStepper_stepComplete_subTitle: `Propriétaires de porcs du Québec`,
  producerRequestAccessStepComplete_section1: `Veuillez confirmer les données suivantes et transmettre votre demande`,
  producerRequestAccessStepComplete_section2: `Formulaire d’inscription au système de monitorage de l’utilisation des antibiotiques`,
  producerRequestAccessStepComplete_section3: `Consentements`,
  producerRequestAccessStepComplete_identificationConsent_checkbox: `Je consens à ce que les renseignements saisis dans ce formulaire soient transmis aux Éleveurs de porcs du Québec, à l’unique fin qu’ils puissent confirmer que je suis bel et bien propriétaire de porcs hébergés sur des sites localisés au Québec.`,
  producerRequestAccessStepComplete_monitoringConsent_checkbox: `Je consens à ce que tous les porcs hébergés sur des sites localisés au Québec et dont je suis propriétaire participent à la portion volontaire du monitorage jusqu’à ce que je n’en sois plus propriétaire, jusqu’à ce que je retire mon consentement ou jusqu’à un maximum de sept (7) ans.`,
  activeIngredient_tableLister_modal_headerMedicationType: `Type de médicament`,
  activeIngredient_tableLister_modal_removeMedicationType: `Retirer le type de médicament`,
  activeIngredient_tableLister_modal_listMedicationType: `Liste des types de médicaments`,
  activeIngredient_tableLister_modal_addMedicationType: `Ajouter un type de médicament`,
  system: {
    admin: {
      title: 'Administration du système',
      simplitraceAnimalsStatsSync: {
        title: 'Synchronisation SimpliTrace — Statistiques animaux',
        description:
          'Sélectionne l’année à synchroniser. En cliquant sur “Envoyer”, une requête sera faite au backend pour déclencher l’import des statistiques SimpliTrace pour l’année choisie.',
        yearLabel: 'Année',
        yearPlaceholder: 'Choisir une année',
        submit: 'Envoyer la demande',
        notifications: {
          missingYearTitle: 'Année manquante',
          missingYearMessage: 'Choisis une année avant d’envoyer la demande.',
          failedTitle: 'Échec',
          failedMessage: 'Le backend a refusé la demande ou une erreur est survenue.',
          sentTitle: 'Demande envoyée',
          sentMessage:
            'La synchronisation SimpliTrace pour l’année {year} a été envoyée au backend.',
          networkErrorTitle: 'Erreur réseau',
          unknownError: 'Erreur inconnue',
        },
      },
    },
  },
  // Specific keys for user authentication
  auth: {
    account: {
      infoTitle: 'Informations du compte',
    },
    attestraConnect: {
      confirm: `Avez-vous déjà un compte Service d'authentification?`,
      errorMessage:
        'Veuillez réessayer ou contacter Attestra. Si vous avez déjà un compte, connectez vous au lieu de vous inscrire.',
      errorTitle: 'Impossible de créer le compte.',
      title: `Inscription à Service d'authentification`,
      useTermTitle: 'CONDITIONS D’UTILISATION ATTESTRA-CONNECT',
      useTermText:
        'Introduction{br}' +
        'Les présentes conditions d\'utilisation (ci-après dénommées les "Conditions") régissent votre utilisation dans service d\'authentification, ci-après dénommé «l’Application», et elles représentent l’ensemble des droits et obligations liant ATTESTRA et tous ses utilisateurs. Aucune déclaration verbale ou écrite d’un employé d’ATTESTRA ne peut avoir pour effet de modifier ou de se substituer aux présentes conditions d’utilisation.{br}' +
        "Veuillez lire attentivement les présentes modalités, car en accédant à l’Application ou en l'utilisant de quelque manière que ce soit, vous acceptez d'être lié par les présentes modalités et conditions.{br}" +
        "Si vous n'acceptez pas ces conditions, c’est votre droit, mais vous devez cesser immédiatement toute utilisation de l’Application.{br}" +
        '1. Absence de garantie{br}' +
        'L’Application vise principalement à recevoir et entreposer les données relatives aux obligations des différents intervenants dans le cadre de la Loi sur la protection sanitaire des animaux (RLRQ, chapitre P-42). ATTESTRA peut modifier à son gré ou supprimer toute fonctionnalité, à n’importe quel moment, en vous en avisant ou non.{br}' +
        'Aucune garantie n’est donnée que l’Application soit accessible et fonctionnelle, en totalité ou en partie, en tout temps. Nous nous réservons le droit de suspendre l’accès au Site Web pour l’ensemble du public ou pour un ou plusieurs visiteurs ou utilisateurs en particulier pour toute période, à notre entière discrétion.{br}' +
        '2. Limitation de responsabilité{br}' +
        'L’Application est fournie « tel quelle » et ATTESTRA ne fait aucune déclaration ni garantie quant à son fonctionnement, à son accessibilité ou à son adéquation à un usage particulier.{br}' +
        'L’utilisation de l’Application caractérise l’acceptation des présentes conditions d’utilisation, vous renoncez donc à exercer tout recourt contre ATTESTRA ou ses employés, qui serait fondé sur une matière exclue en vertu du présent article.{br}' +
        '3. Propriété intellectuelle{br}' +
        "Le contenu de cette application, y compris mais sans s'y limiter, les textes, les graphiques, les images, les vidéos, les audios, les logos et le code source, sont protégés par des lois sur la propriété intellectuelle et est la propriété du ministère de l'Agriculture, des Pêcheries et de l'Alimentation du Québec (MAPAQ).{br}" +
        'Des noms, mots, titres, phrases, logos, dessins, graphiques, icônes et marques affichées sur cette application peuvent constituer des marques de commerce d’ATTESTRA ou de tiers.{br}' +
        'Nous prenons des mesures raisonnables pour ne pas enfreindre des droits de propriété intellectuelle lors de l’affichage de contenu sur cette application. Cependant, nous ne pouvons le garantir, et nous retirons tout élément enfreignant le droit de propriété intellectuel d’un tiers lorsque porté à notre attention.{br}' +
        'Vous ne pouvez pas reproduire, distribuer, modifier, afficher publiquement, transmettre ou exploiter de quelque manière que ce soit le contenu de cette application sans notre autorisation préalable.{br}' +
        '4. Utilisation acceptable{br}' +
        'Vous n’êtes pas autorisé à utiliser cette application ou ses fonctionnalités pour atteindre un but qui soit illégal ou interdit en vertu des présentes conditions :{br}' +
        "• Vous acceptez d'utiliser cette application conformément à toutes les lois et réglementations applicables, et acceptez également de ne pas enfreindre les droits de propriété intellectuelle de toute personne.• Vous acceptez de ne pas utiliser cette application de manière frauduleuse ou abusive, ni d'interférer avec son bon fonctionnement.• Vous acceptez de ne pas accéder à des parties de l’application auxquelles vous n'êtes pas autorisées, de ne pas tenter de contourner les mesures de sécurité existantes et de ne pas utiliser de méthodes automatisées pour collecter des informations à partir de l’application.{br}" +
        'Dans un cas de suspicion de manquement ou d’atteinte à ce qui précède, ATTESTRA se réserve le droit de restreindre votre utilisation de l’application, y compris de suspendre ou d’annuler tout compte utilisateur.{br}' +
        '5. Liens vers d’autres sites web{br}' +
        'Cette application peut contenir des liens vers des sites web externes, dont ATTESTRA n’exerce aucun contrôle. Ces liens sont fournis uniquement pour votre commodité, et par conséquent, ATTESTRA n’assume aucune responsabilité quant à leur contenu.{br}' +
        'L’utilisation de ces sites web est soumise aux conditions d’utilisation propres à ces sites.{br}' +
        '6. Confidentialité et vie privée{br}' +
        'En ce qui concerne le respect de votre privée et la confidentialité de vos renseignements personnels, ATTESTRA est assujettie, de manière directe ou indirecte, aux lois suivantes :{br}' +
        '• « Loi sur la protection des renseignements personnels dans le secteur privé » (RLRQ, chapitre P-39.1)• « Loi sur l’accès aux documents des organismes publics et sur la protection des renseignements personnels » (RLRQ, chapitre A-2.1)• « Loi concernant le cadre juridique des technologies de l’information » (RLRQ, chapitre C-1.1).{br}' +
        'De plus, notre avis de confidentialité décrit nos pratiques en matière de confidentialité, y compris les renseignements personnels que nous recueillons et traitons à votre sujet, comment nous les utilisons et dans quel but.{br}' +
        '7. Lois applicables, juridiction et règlement des différends{br}' +
        "Les présentes conditions d'utilisation sont régies par les lois de la province de Québec, Canada. Tout litige découlant de l'utilisation du Site sera soumis à la compétence exclusive des tribunaux de la province de Québec.{br}" +
        'Certaines juridictions ne permettent pas qu’un contrat soit régi par les lois d’un autre territoire, ou n’autorisent pas les limitations de garanties implicites. Par conséquent, le présent article ainsi que certaines limitations ne peuvent pas s’appliquer à vous.{br}' +
        '8. Langue de traduction{br}' +
        'La version française de ces conditions d’utilisations prévaut sur toute autre traduction afin d’éviter toute interprétation disparate.{br}' +
        '9. Modifications des conditions{br}' +
        "Nous nous réservons le droit d’effectuer des modifications à nos conditions d'utilisation, à notre entière discrétion et sans préavis, par conséquent, il est de votre responsabilité de consulter régulièrement les conditions d'utilisation pour vous tenir informé des éventuelles modifications.{br}" +
        '10. Questions, suggestions, commentaires ou plaintes{br}' +
        'Pour toutes questions, suggestions, commentaires ou plaintes sur les conditions d’utilisation ou sur l’application, vous pouvez communiquer avec nous à l’adresse courriel sac@attestra.com.',
    },
    backLogin: 'Retour à la page de connexion',
    errorAuthentication: `Problème d'authentification`,
    errorImpersonation: 'Problème de personnification',
    impersonate: 'Personnifier',
    impersonation: 'Personnification',
    logout: {
      inProgress: 'Déconnexion en cours...',
      redirecting:
        "Veuillez patienter pendant que nous vous redirigeons vers le service d'authentification.",
    },
    login: {
      attempt: 'Tentative de connexion',
      attestraConnect: `Accéder au service d'authentification d'Attestra`,
      errorCredentials: `La combinaison entre le nom d'utilisateur et le mot de passe est invalide.`,
      errorMessage: 'Veuillez réessayer ou contacter Attestra.',
      errorBanner: `La connexion n'a pu être effectuée, veuillez réessayer et si le problème persiste communiquer avec le soutien technique d'Attestra.`,
      errorVet: `Votre courriel de connexion ne correspond pas à votre courriel de correspondance indiqué dans vos préférences de communication à l'Ordre des médecins vétérinaires du Québec (OMVQ) ou votre statut est invalide à l'OMVQ. Si un changement à été fait récemment auprès de l'OVMQ veuillez réessayer une autre journée et si le problème persiste communiquer avec le soutien d'AntibiotiQC.`,
      errorDetails: 'Détails techniques',
      loading: 'Connexion en cours…',
      password: {
        forgot: 'Mot de passe oublié ou inscription incomplète?',
        confirmation: 'Confirmation du mot de passe',
        noMatch: 'Le mot de passe saisi ne correspond pas.',
        new: 'Nouveau mot de passe',
        resetError: 'Échec de la réinitialisation.',
        resetInfo:
          'Vous recevrez un courriel de réinitialisation de mot de passe. Veuillez suivre attentivement les instructions qui y sont fournies.',
        resetInstructions:
          'Veuillez saisir un nouveau mot de passe et vous connecter sur AntibiotiQC.',
        resetLoading: 'Mot de passe en cours de réinitialisation.',
        resetRequestError: 'Échec de la demande de réinitialisation.',
        resetRequestLoading: 'Demande de réinitialisation en cours.',
        resetRequestSent: 'Demande de réinitialisation de mot de passe envoyée.',
        resetRequestTitle: 'Demande de réinitialisation du mot de passe.',
        resetRequestInstructions: `Veuillez saisir votre adresse courriel afin de réinitialiser votre mot de passe ou compléter votre inscription si vous n'avez pas pu entrer votre code d'activation reçu par courriel. Vous recevrez un message contenant un lien qui expire dans 10 minutes. Veuillez suivre ce lien pour confirmer votre identité, réinitialiser votre mot de passe et activer votre accès à la plateforme AntibiotiQC.`,
        resetRequestInstructionsSso: `Veuillez saisir votre adresse courriel, code d'activation et nouveau mot de passe pour compléter votre réinitialisation de votre mot de passe.`,
        resetSuccess: 'Mot de passe réinitialisé.',
        resetTitle: 'Réinitialisation de mot de passe',
      },
      signIn: 'Se connecter',
      signUp: `S'inscrire`,
      signUpError: {
        generic: 'Une erreur est survenue lors de la création du compte.',
      },
      signUpTitle: 'Inscription',
      success: 'Connexion réussie',
      title: 'Bienvenue sur AntibiotiQC',
      infoPage: {
        title: 'Nouveau service d’authentification d’Attestra',
        highlight1: 'Sécurité renforcée',
        highlight2: 'Connexion simplifiée',
        alertTitle:
          'Vous avez déjà un compte AntibiotiQC actif, mais vous n’avez pas encore créé votre nouvel identifiant d’authentification d’Attestra?',
        alertText:
          "Lors de la création de votre identifiant, vous devez <bold>absolument</bold> utiliser l'adresse courriel associée à votre compte AntibiotiQC. Cette adresse permettra de lier votre nouvel identifiant à votre compte existant.",
        instruction: 'Cliquez sur le bouton ci-dessous pour :',
        instructionList1:
          'Créer votre identifiant d’authentification (et un compte AntibiotiQC, si vous n’en avez pas déjà un)',
        instructionList2: '- ou -',
        instructionList3: 'Vous connecter à votre compte AntibiotiQC.',
        instruction2:
          'Si vous êtes un <semiBold>médecin vétérinaire</semiBold>, utilisez l’adresse courriel de correspondance inscrite dans vos préférences de communication à l’OMVQ pour vous authentifier.',
        needHelpTitle: 'Besoin d’aide ?',
        needHelpText1: `Communiquez avec l'équipe du Service à la clientèle d'Attestra via le <requestManagementLink>portail en ligne de gestion des demandes</requestManagementLink> ou en laissant un message au 438 222-1311 (sans frais : 1 866 220-7115).`,
      },
    },
    selectEmail: 'Choisir un utilisateur',
    signOut: 'Se déconnecter',
  },
};

export default messages;
